/**
 * 最后一次保养进店类型
 */
export const TYPE_MT_LAST_MAINTENANCE_STORE_TYPE = 'mtLastMaintenanceStoreType'

/**
 * 字段类型
 */
export const TYPE_ANALYSIS_FIELD_TYPE = 'analysisFieldType'

/**
 * 数据类型
 */
export const TYPE_CSM_DATA_TYPE = 'csmDataType'

/**
 * 流失去向
 */
export const TYPE_CSM_LOSS_DIRECTION = 'csmLossDirection'

/**
 * 流失原因
 */
export const TYPE_CSM_LOSS_REASON = 'csmLossReason'

/**
 * 维修类别
 */
export const TYPE_CSM_MAINTAIN_CATEGORY = 'csmMaintainCategory'

/**
 * 购车门店
 */
export const TYPE_CSM_BOUGHT_STORE = 'csmBoughtStore'

/**
 * 车辆状态
 */
export const TYPE_CSM_VEHICLE_STATUS = 'csmVehicleStatus'

/**
 * 活动车辆状态
 */
export const TYPE_CSM_ACTIVITY_VEHICLE_STATUS = 'csmActivityVehicleStatus'

/**
 * 精品活动车辆状态
 */
export const TYPE_CSM_BOUTIQUE_ACTIVITY_VEHICLE_STATUS = 'csmBoutiqueActivityVehicleStatus'

/**
 * 通话状态
 */
export const TYPE_CSM_CALL_STATUS = 'csmCallStatus'

/**
 * 回店可能性
 */
export const TYPE_CSM_BACK_STORE_POSSIBILITY = 'csmBackStorePossibility'

/**
 * 客户状态
 */
export const TYPE_CSM_CUSTOMER_STATUS = 'csmCustomerStatus'

/**
 * 邀约状态
 */
export const TYPE_CSM_INVITATION_STATUS = 'csmInvitationStatus'

/**
 * 进店状态
 */
export const TYPE_CSM_ENTER_STORE = 'csmEnterStore'

/**
 * 精品活动进店状态
 */
export const TYPE_CSM_BOUTIQUE_ENTER_STORE = 'csmBoutiqueEnterStore'

/**
 * 状态
 */
export const TYPE_CSM_INVITATION_REQ_EXT_STATUS = 'csmInvitationReqExtStatus'

/**
 * 申请人
 */
export const TYPE_CSM_INVITATION_REQ_REQUESTOR = 'csmInvitationReqRequestor'

/**
 * 活动类别
 */
export const TYPE_CSM_ACTIVITY_CATEGORY = 'csmActivityCategory'

/**
 * 邀约类别
 */
export const TYPE_CSM_INVITATION_CATEGORY = 'csmInvitationCategory'

/**
 * 预约状态
 */
export const TYPE_CSM_RESERVATION_STATUS = 'csmReservationStatus'

/**
 * 是否到店
 */
export const TYPE_CSM_IS_ARRIVED_STORE = 'csmIsArrivedStore'

/**
 * 来源
 */
export const TYPE_CSM_RESERVATION_CHANNEL = 'csmReservationChannel'

/**
 * 无效原因
 */
export const TYPE_CSM_INVALID_REASON = 'csmInvalidReason'

/**
 * 预约时间
 */
export const TYPE_CSM_RESERVATION_TIME = 'csmReservationTime'

/**
 * 操作类型
 */
export const TYPE_CSM_OPERATION_TYPE = 'csmOperationType'

/**
 * 回访类型
 */
export const TYPE_CSM_VISIT_CATEGORY = 'csmVisitCategory'

/**
 * 电话状态
 */
export const TYPE_CSM_PHONE_STATUS = 'csmPhoneStatus'

/**
 * 车辆产地
 */
export const TYPE_CSM_VEHICLE_ORIGIN = 'csmVehicleOrigin'

/**
 * Portal维修类别
 */
export const TYPE_CSM_PORTAL_MAINTAIN_CATEGORY = 'csmPortalMaintainCategory'

/**
 * 邀约记录数据来源
 */
export const TYPE_CSM_INVITATION_DATA_SOURCE = 'csmInvitationDataSource'

/**
 * 车辆维修记录来源类别
 */
export const TYPE_CSM_MAINTENANCE_SOURCE_TYPE = 'csmMaintenanceSourceType'

/**
 * 车型名称
 */
export const TYPE_CSM_VEHICLE_NAME = 'csmVehicleName'

/**
 * 上门地点
 */
export const TYPE_CSM_DOOR_TO_DOOR_LOCATION = 'csmDoorToDoorLocation'

/**
 * 用车地点
 */
export const TYPE_CSM_CAR_LOCATION = 'csmCarLocation'

/**
 * 接待顾问是否指定
 */
export const TYPE_CSM_CUSTOMER_DESIGNATED = 'csmCustomerDesignated'

/**
 * 客户关系状态
 */
export const TYPE_IIM_CUSTOMER_RELATION = 'iimCustomerRelation'

/**
 * 接触轮次
 */
export const TYPE_IIM_INVITATION_ROUNDS = 'iimInvitationRounds'

/**
 * 保险险种
 */
export const TYPE_IIM_INSURANCE = 'iimInsurance'

/**
 * 通话状态
 */
export const TYPE_IIM_CALL_STATUS = 'iimCallStatus'

/**
 * 续保状态
 */
export const TYPE_IIM_RENEWAL_OF_INSURANCE_STATUS = 'iimRenewalOfInsuranceStatus'

/**
 * 邀约状态
 */
export const TYPE_IIM_INVITATION_STATUS = 'iimInvitationStatus'

/**
 * 客户类别
 */
export const TYPE_IIM_CUSTOMER_TYPE = 'iimCustomerType'

/**
 * 车型名称
 */
export const TYPE_IIM_VEHICLE_NAME = 'iimVehicleName'

/**
 * 客户续保状态
 */
export const TYPE_IIM_CALL_STATUS_INSURANCE_STATUS = 'iimCallStatusInsuranceStatus'

/**
 * 营销活动实例状态
 */
export const TYPE_DEMO_MARKETING_ACTIVITY_STATUS = 'demoMarketingActivityStatus'

/**
 * 营销活动推荐状态
 */
export const TYPE_DEMO_SUGGEST_MARKETING_ACTIVITY_STATUS = 'demoSuggestMarketingActivityStatus'

/**
 * 营销活动推荐计算周期
 */
export const TYPE_DEMO_SUGGEST_MARKETING_ACTIVITY_CALCULATION_CYCLE = 'demoSuggestMarketingActivityCalculationCycle'

/**
 * 活动类别
 */
export const TYPE_CSM_MARKETING_ACTIVITY_CATEGORY = 'csmMarketingActivityCategory'

/**
 * 模型活动车辆状态
 */
export const TYPE_DEMO_ACTIVITY_VEHICLE_STATUS = 'demoActivityVehicleStatus'

/**
 * 模型日常车辆状态
 */
export const TYPE_DEMO_DAILY_VEHICLE_STATUS = 'demoDailyVehicleStatus'

/**
 * 模型日常维修类别
 */
export const TYPE_DEMO_DAILY_MAINTAIN_CATEGORY = 'demoDailyMaintainCategory'

/**
 * 保险公司
 */
export const TYPE_IIM_INSURANCE_COMPANY = 'iimInsuranceCompany'

/**
 * 子险种类别主险
 */
export const TYPE_IIM_SON_INSURANCE_MAIN = 'iimSonInsuranceMain'

/**
 * 子险种类别附加险
 */
export const TYPE_IIM_SON_INSURANCE_ATTACH = 'iimSonInsuranceAttach'

/**
 * 商业子险种类别
 */
export const TYPE__IIM_BRANCH_OF_INSURANCE = 'IimBranchOfInsurance'

/**
 * 客户级别
 */
export const TYPE_BASIC_DATA_CUSTOMER_LEVEL = 'basicDataCustomerLevel'

/**
 * 客户类别
 */
export const TYPE_BASIC_DATA_CUSTOMER_CATEGORY = 'basicDataCustomerCategory'

/**
 * 延保标识
 */
export const TYPE_CSM_EXTENDED_WARRANTY_LOGO = 'csmExtendedWarrantyLogo'

/**
 * 新车送保
 */
export const TYPE_CSM_NEW_CAR_TO_SEND_CONFIRMED = 'csmNewCarToSendConfirmed'

/**
 * 本公司售车
 */
export const TYPE_CSM_OUR_COMPANY_SELLS_CARS = 'csmOurCompanySellsCars'

/**
 * 年度任务名称
 */
export const TYPE_CSM_TASK_NAME = 'csmTaskName'

/**
 * 客户意见
 */
export const TYPE_CSR_CUSTOMER_OPINION = 'csrCustomerOpinion'

/**
 * 回访状态
 */
export const TYPE_CSR_ACCESS_PHONE_STATUS = 'csrAccessPhoneStatus'

/**
 * 销售类型
 */
export const TYPE_CSM_PACKAGE_SALE_TYPE = 'csmPackageSaleType'

/**
 * 备件状态
 */
export const TYPE_CSM_PARTS_STATUS = 'csmPartsStatus'

/**
 * 是否有效
 */
export const TYPE_UCT_VALIDITY = 'uctValidity'

/**
 * 商机阶段
 */
export const TYPE_UCT_CARRIED_OUT_STATUS = 'uctCarriedOutStatus'

/**
 * 商机类型
 */
export const TYPE_UCT_COMMERCIAL_OPPORTUNITY_TYPE = 'uctCommercialOpportunityType'

/**
 * 商机来源
 */
export const TYPE_UCT_COMMERCIAL_OPPORTUNITY_SOURCE = 'uctCommercialOpportunitySource'

/**
 * 车身颜色
 */
export const TYPE_UCT_CURRENT_THE_COLOR_OF_CAR = 'uctCurrentTheColorOfCar'

/**
 * 燃油类型
 */
export const TYPE_UCT_FUEL_TYPE = 'uctFuelType'

/**
 * 排放标准
 */
export const TYPE_UCT_CURRENT_EMISSION_STANDARDS = 'uctCurrentEmissionStandards'

/**
 * 驱动方式
 */
export const TYPE_UCT_CURRENT_DRIVING_METHOD = 'uctCurrentDrivingMethod'

/**
 * 通话状态
 */
export const TYPE_UCT_CALL_STATUS = 'uctCallStatus'

/**
 * 线索状态
 */
export const TYPE_UCT_CLUE_STATUS = 'uctClueStatus'

/**
 * 战败原因
 */
export const TYPE_UCT_REASON_FOR_FAILURE = 'uctReasonForFailure'

/**
 * 商机状态
 */
export const TYPE_UCT_COMMERCIAL_OPPORTUNITY_STATUS = 'uctCommercialOpportunityStatus'

/**
 * 商机执行状态
 */
export const TYPE_UCT_OPPORTUNITY_EXECUTION_STATUS = 'uctOpportunityExecutionStatus'

/**
 * 变速箱
 */
export const TYPE_UCT_CEARBOX = 'uctCearbox'

/**
 * 精品活动战败原因
 */
export const TYPE_CSM_REASONS_FOR_DEFEAT_IN_BOUTIQUE_ACTIVITIES = 'csmReasonsForDefeatInBoutiqueActivities'

/**
 * 续保战败原因
 */
export const TYPE_CAUSE_OF_DEFEAT = 'causeOfDefeat'

/**
 * 客户类别
 */
export const TYPE_CSM_CUSTOMER_TYPE = 'csmCustomerType'

/**
 * 新增客户类别
 */
export const TYPE_CSM_ADD_CUSTOMER_TYPE = 'csmAddCustomerType'

/**
 * 购车日期按月查询条件
 */
export const TYPE_DATE_OF_PURCHASE_BY_MONTH = 'dateOfPurchaseByMonth'

/**
 * 销售状态
 */
export const TYPE_IIM_LAST_SALE_STATUS = 'iimLastSaleStatus'

/**
 * 日志类型
 */
export const TYPE_IIM_TYPE = 'iimType'

/**
 * 沟通事项
 */
export const TYPE_CSM_COMMUNICATION_MATTERS = 'csmCommunicationMatters'

/**
 * 延保状态
 */
export const TYPE_CSM_EXTENSION_STATUS = 'csmExtensionStatus'

/**
 * 问卷类型
 */
export const TYPE_SURVEY_PAGER_TYPE = 'surveyPagerType'

/**
 * 问题类型
 */
export const TYPE_SURVEY_OPTION_TYPE = 'surveyOptionType'

/**
 * 问卷状态
 */
export const TYPE_SURVEY_PAGER_STATUS = 'surveyPagerStatus'

/**
 * 认证方式
 */
export const TYPE_MEMBER_VERIFICATION_MANNER = 'memberVerificationManner'

/**
 * 认证状态
 */
export const TYPE_MEMBER_VERIFICATION_STATUS = 'memberVerificationStatus'

/**
 * 卡券类型
 */
export const TYPE_COUPON_CUPON_TYPE = 'couponCuponType'

/**
 * 卡券定义状态
 */
export const TYPE_COUPON_DEFINITION_STATUS = 'couponDefinitionStatus'

/**
 * 卡券到期类型
 */
export const TYPE_COUPON_EXPIRES_TYPE = 'couponExpiresType'

/**
 * 购买类型
 */
export const TYPE_APPLICATION_TYPE = 'applicationType'

/**
 * 所属部门
 */
export const TYPE_DEPARTMENT = 'department'

/**
 * 核销方式
 */
export const TYPE_CANCELLATION_AFTER_VERIFICATION_TYPE = 'cancellationAfterVerificationType'

/**
 * 会员来源
 */
export const TYPE_MEMBER_MEMBER_SOURCE = 'memberMemberSource'

/**
 * 卡券使用状态
 */
export const TYPE_COUPON_USE_STATUS = 'couponUseStatus'

/**
 * 核销地点
 */
export const TYPE_VERIFY_SALES_LOCATION = 'verifySalesLocation'

/**
 * 审批选项
 */
export const TYPE_APPROVAL_OPTIONS = 'approvalOptions'

/**
 * 车辆归属地
 */
export const TYPE_CAR_ATTRIBUTION = 'carAttribution'

/**
 * 处理状态
 */
export const TYPE_HANDLE_STATUS = 'handleStatus'

/**
 * 是否有效
 */
export const TYPE_IS_EFFECTIVE = 'isEffective'

/**
 * 卡券定义审批状态
 */
export const TYPE_COUPON_DEFINITION_APPROVE_STATUS = 'couponDefinitionApproveStatus'

/**
 * 卡券发放审批状态
 */
export const TYPE_COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS = 'couponCouponInstanceBuyApproveStatus'

/**
 * 金融项目定义状态
 */
export const TYPE_FINANCIAL_PROJECT_DEFINITION_STATUS = 'financialProjectDefinitionStatus'

/**
 * 产品类型
 */
export const TYPE_MEMBER_PRODUCT_TYPE = 'memberProductType'

/**
 * 会员储值记录类型
 */
export const TYPE_MEMBER_STORED_VALUE_RECORD_TYPE = 'memberStoredValueRecordType'

/**
 * 婚姻
 */
export const TYPE_MARITAL_STATUS = 'maritalStatus'

/**
 * 职业
 */
export const TYPE_OCCUPATION = 'occupation'

/**
 * 月收入
 */
export const TYPE_MONTHLY_INCOME = 'monthlyIncome'

/**
 * 兴趣爱好
 */
export const TYPE_HOBBY = 'hobby'

/**
 * 车辆用途
 */
export const TYPE_VEHICLE_USE = 'vehicleUse'

/**
 * 年龄
 */
export const TYPE_AGE = 'age'

/**
 * 性别
 */
export const TYPE_GENDER = 'gender'

/**
 * 车厂
 */
export const TYPE_DEPOT = 'depot'

/**
 * 车厂车型
 */
export const TYPE_DEPOT_MODELS = 'depotModels'

/**
 * 回访电话状态
 */
export const TYPE_CSR_CALL_STATUS = 'csrCallStatus'

/**
 * 回访回访状态
 */
export const TYPE_CSR_ACCESS_STATUS = 'csrAccessStatus'

/**
 * 事故统计保险公司
 */
export const TYPE_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY = 'csmAccidentStatisticsInsuranceCompany'

/**
 * 进店记录转化类别
 */
export const TYPE_CSM_INCOMING_RECORD_CONVERSION_CATEGORY = 'csmIncomingRecordConversionCategory'

/**
 * 积分订单状态
 */
export const TYPE_PMALL_POINTS_REDEEM_ORDER_STATUS = 'pmallPointsRedeemOrderStatus'

/**
 * 进店维修积分获取方式
 */
export const TYPE_PMALL_CAR_MAINTENANCE_POINTS_RULE_COMPUTE_TYPE = 'pmallCarMaintenancePointsRuleComputeType'

/**
 * 积分变更记录类型
 */
export const TYPE_PMALL_MEMBER_POINTS_CHANGE_LOG_TYPE = 'pmallMemberPointsChangeLogType'

/**
 * 启用状态
 */
export const TYPE_PMALL_ENABLED_STATE = 'pmallEnabledState'

/**
 * 上架状态
 */
export const TYPE_PMALL_SHELF_STATUS = 'pmallShelfStatus'

/**
 * 奖励类型
 */
export const TYPE_PMALL_REWARD_TYPE = 'pmallRewardType'

/**
 * 权益发放触发原因
 */
export const TYPE_PMALL_REASONS_FOR_TRIGGERING_BENEFITS = 'pmallReasonsForTriggeringBenefits'

/**
 * 卡券导入审批状态
 */
export const TYPE_COUPON_IMPORT_APPROVE_STATUS = 'couponImportApproveStatus'

/**
 * 导入类型
 */
export const TYPE_COUPON_IMPORT_TYPE = 'couponImportType'

/**
 * 试驾预约定义状态
 */
export const TYPE_COUPON_TEST_DRIVE_APPOINTMENT_DEFINITION_STATUS = 'couponTestDriveAppointmentDefinitionStatus'

/**
 * 试驾预约状态
 */
export const TYPE_COUPON_TEST_DRIVE_APPOINTMENT_STATUS = 'couponTestDriveAppointmentStatus'

/**
 * 顶置状态
 */
export const TYPE_MEMBER_ON_TOP_STATUS = 'memberOnTopStatus'

/**
 * 支出或者收入
 */
export const TYPE_MEMBER_EXPENDITURE_OR_INCOME = 'memberExpenditureOrIncome'

/**
 * 积分兑换兑换方式
 */
export const TYPE_MEMBER_HOW_TO_REDEEM_POINTS = 'memberHowToRedeemPoints'

/**
 * 活动定义类别
 */
export const TYPE_MEMBER_ACTIVITY_CLASSIFICATION = 'memberActivityClassification'

/**
 * 预约信息状态
 */
export const TYPE_MEMBER_MEMBER_RESERVATION_INFO_STATUS = 'memberMemberReservationInfoStatus'

/**
 * 预约信息类别
 */
export const TYPE_MEMBER_MEMBER_RESERVATION_INFO_TYPE = 'memberMemberReservationInfoType'

/**
 * 会员提醒大类
 */
export const TYPE_MEMBER_REMIND_BIG_CATEGORY = 'memberRemindBigCategory'

/**
 * 会员提醒小类
 */
export const TYPE_MEMBER_REMIND_SUBCATEGORY = 'memberRemindSubcategory'

/**
 * 数据类型 - 新车客户
 */
export const PROP_CSM_DATA_TYPE_NEW_CAR = '新车客户'

/**
 * 数据类型 - 首保客户
 */
export const PROP_CSM_DATA_TYPE_FIRST_MAINTENANCE = '首保客户'

/**
 * 数据类型 - 二保客户
 */
export const PROP_CSM_DATA_TYPE_SECOND_MAINTENANCE = '二保客户'

/**
 * 数据类型 - 维修客户
 */
export const PROP_CSM_DATA_TYPE_MAINTENANCE = '维修客户'

/**
 * 数据类型 - 仅事故客户
 */
export const PROP_CSM_DATA_TYPE_ONLY_ACCIDENT = '仅事故客户'

/**
 * 数据类型 - 在保流失
 */
export const PROP_CSM_DATA_TYPE_IN_WARRANTY = '在保流失'

/**
 * 数据类型 - 出保流失
 */
export const PROP_CSM_DATA_TYPE_OUT_WARRANTY = '出保流失'

/**
 * 数据类型 - 常规客户
 */
export const PROP_CSM_DATA_TYPE_ORDINARY = '常规客户'

/**
 * 数据类型 - 流失预警
 */
export const PROP_CSM_DATA_TYPE_LOSS_ALARM = '流失预警'

/**
 * 数据类型 - 质保到期
 */
export const PROP_CSM_DATA_TYPE_EXPIRED = '质保到期'

/**
 * 维修类别 - 首保
 */
export const PROP_CSM_MAINTAIN_CATEGORY_0_ = '首保'

/**
 * 维修类别 - 索赔
 */
export const PROP_CSM_MAINTAIN_CATEGORY_1_ = '索赔'

/**
 * 维修类别 - 保养
 */
export const PROP_CSM_MAINTAIN_CATEGORY_2_ = '保养'

/**
 * 维修类别 - 小修
 */
export const PROP_CSM_MAINTAIN_CATEGORY_3_ = '小修'

/**
 * 维修类别 - 大修
 */
export const PROP_CSM_MAINTAIN_CATEGORY_4_ = '大修'

/**
 * 维修类别 - 自费事故
 */
export const PROP_CSM_MAINTAIN_CATEGORY_5_ = '自费事故'

/**
 * 维修类别 - 年审
 */
export const PROP_CSM_MAINTAIN_CATEGORY_7_ = '年审'

/**
 * 维修类别 - PDI
 */
export const PROP_CSM_MAINTAIN_CATEGORY_8_ = 'PDI'

/**
 * 维修类别 - 内修
 */
export const PROP_CSM_MAINTAIN_CATEGORY_9_ = '内修'

/**
 * 维修类别 - 优惠索赔
 */
export const PROP_CSM_MAINTAIN_CATEGORY_G_ = '优惠索赔'

/**
 * 维修类别 - 预PDI
 */
export const PROP_CSM_MAINTAIN_CATEGORY_P_ = '预PDI'

/**
 * 维修类别 - 升级
 */
export const PROP_CSM_MAINTAIN_CATEGORY_S_ = '升级'

/**
 * 维修类别 - 外出救援
 */
export const PROP_CSM_MAINTAIN_CATEGORY_U_ = '外出救援'

/**
 * 维修类别 - 行动
 */
export const PROP_CSM_MAINTAIN_CATEGORY_V_ = '行动'

/**
 * 维修类别 - 召回
 */
export const PROP_CSM_MAINTAIN_CATEGORY_Z_ = '召回'

/**
 * 维修类别 - 忠诚度
 */
export const PROP_CSM_MAINTAIN_CATEGORY_XD_ = '忠诚度'

/**
 * 维修类别 - 免费检查
 */
export const PROP_CSM_MAINTAIN_CATEGORY_M_ = '免费检查'

/**
 * 维修类别 - 保险事故
 */
export const PROP_CSM_MAINTAIN_CATEGORY_A_ = '保险事故'

/**
 * 购车门店 - 本店
 */
export const PROP_CSM_BOUGHT_STORE_THIS_STORE = '本店'

/**
 * 购车门店 - 其他店
 */
export const PROP_CSM_BOUGHT_STORE_OTHER_STORE = '其他店'

/**
 * 车辆状态 - 预约进店保养
 */
export const PROP_CSM_VEHICLE_STATUS_RESERVATION_MAINTENANCE = '预约进店保养'

/**
 * 车辆状态 - 邀约进店保养
 */
export const PROP_CSM_VEHICLE_STATUS_INVITATION_MAINTENANCE = '邀约进店保养'

/**
 * 车辆状态 - 预约上门排期
 */
export const PROP_CSM_VEHICLE_STATUS_APPOINTMENT_SCHEDULE = '预约上门排期'

/**
 * 车辆状态 - 邀约上门排期
 */
export const PROP_CSM_VEHICLE_STATUS_INVITATION_SCHEDULE = '邀约上门排期'

/**
 * 车辆状态 - 未记里程
 */
export const PROP_CSM_VEHICLE_STATUS_LESS_THAN_FIVE_HUNDRED = '未记里程'

/**
 * 车辆状态 - 未到里程
 */
export const PROP_CSM_VEHICLE_STATUS_LESS_THAN_MILEAGE = '未到里程'

/**
 * 车辆状态 - 车已流失，放弃
 */
export const PROP_CSM_VEHICLE_STATUS_CAR_LOSS_ABORT = '车已流失，放弃'

/**
 * 车辆状态 - 活动进店
 */
export const PROP_CSM_VEHICLE_STATUS_ACTIVITY_ENTERS_STORE = '活动进店'

/**
 * 车辆状态 - 活动不进店
 */
export const PROP_CSM_VEHICLE_STATUS_ACTIVITY_ENTERS_NOT_STORE = '活动不进店'

/**
 * 车辆状态 - 进店时间不确定
 */
export const PROP_CSM_VEHICLE_STATUS_ACTIVITY_ENTERS_UNCERTAIN_STORE = '进店时间不确定'

/**
 * 车辆状态 - 流失预警
 */
export const PROP_CSM_VEHICLE_STATUS_CAR_LOSS_ALARM = '流失预警'

/**
 * 车辆状态 - 已保养
 */
export const PROP_CSM_VEHICLE_STATUS_MAINTAINED = '已保养'

/**
 * 活动车辆状态 - 活动进店
 */
export const PROP_CSM_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_STORE = '活动进店'

/**
 * 活动车辆状态 - 活动不进店
 */
export const PROP_CSM_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_NOT_STORE = '活动不进店'

/**
 * 活动车辆状态 - 进店时间不确定
 */
export const PROP_CSM_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_UNCERTAIN_STORE = '进店时间不确定'

/**
 * 活动车辆状态 - 未到里程
 */
export const PROP_CSM_ACTIVITY_VEHICLE_STATUS_UNREACHED_MILEAGE = '未到里程'

/**
 * 精品活动车辆状态 - 跟踪
 */
export const PROP_CSM_BOUTIQUE_ACTIVITY_VEHICLE_STATUS_BOUTIQUE_ACTIVITY_TRACK = '跟踪'

/**
 * 精品活动车辆状态 - 预定
 */
export const PROP_CSM_BOUTIQUE_ACTIVITY_VEHICLE_STATUS_BOUTIQUE_ACTIVITY_PREORDAIN = '预定'

/**
 * 精品活动车辆状态 - 战败
 */
export const PROP_CSM_BOUTIQUE_ACTIVITY_VEHICLE_STATUS_BOUTIQUE_ACTIVITY_DEFEATED = '战败'

/**
 * 通话状态 - 有效沟通
 */
export const PROP_CSM_CALL_STATUS_VALID_INTERVIEW = '有效沟通'

/**
 * 通话状态 - 未接通
 */
export const PROP_CSM_CALL_STATUS_NOT_INTERVIEWED = '未接通'

/**
 * 通话状态 - 无效电话
 */
export const PROP_CSM_CALL_STATUS_INVALID_CALL = '无效电话'

/**
 * 通话状态 - 无效沟通
 */
export const PROP_CSM_CALL_STATUS_INVALID_INTERVIEW = '无效沟通'

/**
 * 通话状态 - 未拨打
 */
export const PROP_CSM_CALL_STATUS_NOT_DIALED = '未拨打'

/**
 * 通话状态 - 没联系上
 */
export const PROP_CSM_CALL_STATUS_NOT_CONTACTED = '没联系上'

/**
 * 通话状态 - 没联系上-近期就来
 */
export const PROP_CSM_CALL_STATUS_NOT_CONTACTED_NOT_COMING_SOON = '没联系上-近期就来'

/**
 * 客户状态 - 首保未进厂
 */
export const PROP_CSM_CUSTOMER_STATUS_FIRST_MAINTENANCE_NO_ENTERED_STORE = '首保未进厂'

/**
 * 客户状态 - 首保回厂
 */
export const PROP_CSM_CUSTOMER_STATUS_FIRST_MAINTENANCE_ENTERED_STORE = '首保回厂'

/**
 * 客户状态 - 二保回厂
 */
export const PROP_CSM_CUSTOMER_STATUS_SECOND_MAINTENANCE_ENTERED_STORE = '二保回厂'

/**
 * 客户状态 - 保养忠实
 */
export const PROP_CSM_CUSTOMER_STATUS_MAINTENANCE_LOYAL = '保养忠实'

/**
 * 客户状态 - 保养流失
 */
export const PROP_CSM_CUSTOMER_STATUS_MAINTENANCE_LOST = '保养流失'

/**
 * 客户状态 - 保养回厂
 */
export const PROP_CSM_CUSTOMER_STATUS_MAINTENANCE_ENTERED_FACTORY = '保养回厂'

/**
 * 客户状态 - 保养三次
 */
export const PROP_CSM_CUSTOMER_STATUS_MAINTENANCE_QTY_3 = '保养三次'

/**
 * 客户状态 - 进厂三次
 */
export const PROP_CSM_CUSTOMER_STATUS_ENTERED_FACTORY_QTY_3 = '进厂三次'

/**
 * 客户状态 - 流失预警
 */
export const PROP_CSM_CUSTOMER_STATUS_LOSS_ALARM = '流失预警'

/**
 * 客户状态 - 维修进厂
 */
export const PROP_CSM_CUSTOMER_STATUS_MAINTENANCE_TO_FACTORY = '维修进厂'

/**
 * 客户状态 - 事故进厂
 */
export const PROP_CSM_CUSTOMER_STATUS_ACCIDENT_TO_FACTORY = '事故进厂'

/**
 * 客户状态 - 流失
 */
export const PROP_CSM_CUSTOMER_STATUS_LOSS = '流失'

/**
 * 客户状态 - 无效休眠
 */
export const PROP_CSM_CUSTOMER_STATUS_INVALID_HIBERNATE = '无效休眠'

/**
 * 客户状态 - 放弃
 */
export const PROP_CSM_CUSTOMER_STATUS_ABORT = '放弃'

/**
 * 邀约状态 - 已邀约
 */
export const PROP_CSM_INVITATION_STATUS_INVITATION_STATUS_SUCESS = '已邀约'

/**
 * 邀约状态 - 未邀约
 */
export const PROP_CSM_INVITATION_STATUS_INVITATION_STATUS_NOT_STARTED = '未邀约'

/**
 * 进店状态 - 已进店
 */
export const PROP_CSM_ENTER_STORE_TO_SHOP = '已进店'

/**
 * 进店状态 - 未进店
 */
export const PROP_CSM_ENTER_STORE_NOT_TO_SHOP = '未进店'

/**
 * 精品活动进店状态 - 待确认
 */
export const PROP_CSM_BOUTIQUE_ENTER_STORE_TO_BE_CONFIRMED = '待确认'

/**
 * 精品活动进店状态 - 成功
 */
export const PROP_CSM_BOUTIQUE_ENTER_STORE_SUCCESS = '成功'

/**
 * 精品活动进店状态 - 失败
 */
export const PROP_CSM_BOUTIQUE_ENTER_STORE_FAILURE = '失败'

/**
 * 状态 - 进行中
 */
export const PROP_CSM_INVITATION_REQ_EXT_STATUS_INVITATION_PROCESSING = '进行中'

/**
 * 状态 - 已结束
 */
export const PROP_CSM_INVITATION_REQ_EXT_STATUS_INVITATION_FINISHED = '已结束'

/**
 * 状态 - 驳回
 */
export const PROP_CSM_INVITATION_REQ_EXT_STATUS_INVITATION_REJECT = '驳回'

/**
 * 状态 - 终止
 */
export const PROP_CSM_INVITATION_REQ_EXT_STATUS_INVITATION_TERMINATED = '终止'

/**
 * 状态 - 待审批
 */
export const PROP_CSM_INVITATION_REQ_EXT_STATUS_INVITATION_PENDING = '待审批'

/**
 * 活动类别 - 售后活动
 */
export const PROP_CSM_ACTIVITY_CATEGORY_ACTIVITY_CATEGORY_AFTER_SALE = '售后活动'

/**
 * 活动类别 - 精品活动
 */
export const PROP_CSM_ACTIVITY_CATEGORY_ACTIVITY_CATEGORY_BOUTIQUE = '精品活动'

/**
 * 邀约类别 - 日常邀约
 */
export const PROP_CSM_INVITATION_CATEGORY_ORDINARY = '日常邀约'

/**
 * 邀约类别 - 售后活动邀约
 */
export const PROP_CSM_INVITATION_CATEGORY_ACTIVITY = '售后活动邀约'

/**
 * 邀约类别 - 延保邀约
 */
export const PROP_CSM_INVITATION_CATEGORY_EXTENSION = '延保邀约'

/**
 * 邀约类别 - 精品活动邀约
 */
export const PROP_CSM_INVITATION_CATEGORY_BOUTIQUE_ACTIVITY = '精品活动邀约'

/**
 * 邀约类别 - 质量担保期邀约
 */
export const PROP_CSM_INVITATION_CATEGORY_WARRANTY_PERIOD = '质量担保期邀约'

/**
 * 邀约类别 - 客户关怀邀约
 */
export const PROP_CSM_INVITATION_CATEGORY_CARE_CUSTOMER = '客户关怀邀约'

/**
 * 预约状态 - 预约中
 */
export const PROP_CSM_RESERVATION_STATUS_PROCESSING = '预约中'

/**
 * 预约状态 - 取消
 */
export const PROP_CSM_RESERVATION_STATUS_CANCELED = '取消'

/**
 * 回访类型 - 0-
 */
export const PROP_CSM_VISIT_CATEGORY_0_ = '0-'

/**
 * 回访类型 - 1-
 */
export const PROP_CSM_VISIT_CATEGORY_1_ = '1-'

/**
 * 回访类型 - 2-
 */
export const PROP_CSM_VISIT_CATEGORY_2_ = '2-'

/**
 * 回访类型 - 3-
 */
export const PROP_CSM_VISIT_CATEGORY_3_ = '3-'

/**
 * 回访类型 - 5-
 */
export const PROP_CSM_VISIT_CATEGORY_5_ = '5-'

/**
 * 回访类型 - 8-
 */
export const PROP_CSM_VISIT_CATEGORY_8_ = '8-'

/**
 * 回访类型 - G-
 */
export const PROP_CSM_VISIT_CATEGORY_G_ = 'G-'

/**
 * 回访类型 - P-
 */
export const PROP_CSM_VISIT_CATEGORY_P_ = 'P-'

/**
 * 回访类型 - S-
 */
export const PROP_CSM_VISIT_CATEGORY_S_ = 'S-'

/**
 * 回访类型 - V-
 */
export const PROP_CSM_VISIT_CATEGORY_V_ = 'V-'

/**
 * 回访类型 - Z-
 */
export const PROP_CSM_VISIT_CATEGORY_Z_ = 'Z-'

/**
 * 回访类型 - XD_
 */
export const PROP_CSM_VISIT_CATEGORY_XD_ = 'XD_'

/**
 * 电话状态 - 呼出
 */
export const PROP_CSM_PHONE_STATUS_CALL_OUT = '呼出'

/**
 * 电话状态 - 来电
 */
export const PROP_CSM_PHONE_STATUS_CALL_IN = '来电'

/**
 * 车辆产地 - 国产
 */
export const PROP_CSM_VEHICLE_ORIGIN_DOMESTIC = '国产'

/**
 * 车辆产地 - 进口
 */
export const PROP_CSM_VEHICLE_ORIGIN_IMPORTED = '进口'

/**
 * Portal维修类别 - 首保
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_0 = '首保'

/**
 * Portal维修类别 - 索赔
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_1 = '索赔'

/**
 * Portal维修类别 - 保养
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_2 = '保养'

/**
 * Portal维修类别 - 小修
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_3 = '小修'

/**
 * Portal维修类别 - 大修
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_4 = '大修'

/**
 * Portal维修类别 - 自费事故
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_5 = '自费事故'

/**
 * Portal维修类别 - 年审
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_7 = '年审'

/**
 * Portal维修类别 - PDI
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_8 = 'PDI'

/**
 * Portal维修类别 - 内修
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_9 = '内修'

/**
 * Portal维修类别 - 优惠索赔
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_G = '优惠索赔'

/**
 * Portal维修类别 - 预PDI
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_P = '预PDI'

/**
 * Portal维修类别 - 升级
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_S = '升级'

/**
 * Portal维修类别 - 外出救援
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_U = '外出救援'

/**
 * Portal维修类别 - 行动
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_V = '行动'

/**
 * Portal维修类别 - 召回
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_Z = '召回'

/**
 * Portal维修类别 - 免费检查
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_M = '免费检查'

/**
 * Portal维修类别 - 保险事故
 */
export const PROP_CSM_PORTAL_MAINTAIN_CATEGORY_A = '保险事故'

/**
 * 邀约记录数据来源 - 迈道
 */
export const PROP_CSM_INVITATION_DATA_SOURCE_MDC = '迈道'

/**
 * 邀约记录数据来源 - 洞察分析平台
 */
export const PROP_CSM_INVITATION_DATA_SOURCE_SIP = '洞察分析平台'

/**
 * 车辆维修记录来源类别 - DMS
 */
export const PROP_CSM_MAINTENANCE_SOURCE_TYPE_DMS = 'DMS'

/**
 * 车辆维修记录来源类别 - Portal
 */
export const PROP_CSM_MAINTENANCE_SOURCE_TYPE_PORTAL = 'Portal'

/**
 * 车型名称 - A1
 */
export const PROP_CSM_VEHICLE_NAME_A1 = 'A1'

/**
 * 车型名称 - S3
 */
export const PROP_CSM_VEHICLE_NAME_S3 = 'S3'

/**
 * 车型名称 - A3
 */
export const PROP_CSM_VEHICLE_NAME_A3 = 'A3'

/**
 * 车型名称 - A4
 */
export const PROP_CSM_VEHICLE_NAME_A4 = 'A4'

/**
 * 车型名称 - A5
 */
export const PROP_CSM_VEHICLE_NAME_A5 = 'A5'

/**
 * 车型名称 - A6
 */
export const PROP_CSM_VEHICLE_NAME_A6 = 'A6'

/**
 * 车型名称 - A7
 */
export const PROP_CSM_VEHICLE_NAME_A7 = 'A7'

/**
 * 车型名称 - A8
 */
export const PROP_CSM_VEHICLE_NAME_A8 = 'A8'

/**
 * 车型名称 - Q2
 */
export const PROP_CSM_VEHICLE_NAME_Q2 = 'Q2'

/**
 * 车型名称 - Q3
 */
export const PROP_CSM_VEHICLE_NAME_Q3 = 'Q3'

/**
 * 车型名称 - Q5
 */
export const PROP_CSM_VEHICLE_NAME_Q5 = 'Q5'

/**
 * 车型名称 - Q5L
 */
export const PROP_CSM_VEHICLE_NAME_Q5L = 'Q5L'

/**
 * 车型名称 - Q7
 */
export const PROP_CSM_VEHICLE_NAME_Q7 = 'Q7'

/**
 * 车型名称 - TT
 */
export const PROP_CSM_VEHICLE_NAME_TT = 'TT'

/**
 * 车型名称 - R8
 */
export const PROP_CSM_VEHICLE_NAME_R8 = 'R8'

/**
 * 车型名称 - Q8
 */
export const PROP_CSM_VEHICLE_NAME_Q8 = 'Q8'

/**
 * 车型名称 - etron
 */
export const PROP_CSM_VEHICLE_NAME_ETRON = 'etron'

/**
 * 车型名称 - XD
 */
export const PROP_CSM_VEHICLE_NAME_XD = 'XD'

/**
 * 客户关系状态 - 正常
 */
export const PROP_IIM_CUSTOMER_RELATION_COSTOMER_RELATION_NORMAL = '正常'

/**
 * 客户关系状态 - 放弃
 */
export const PROP_IIM_CUSTOMER_RELATION_COSTOMER_RELATION_GIVE_UP = '放弃'

/**
 * 客户关系状态 - 废弃
 */
export const PROP_IIM_CUSTOMER_RELATION_COSTOMER_RELATION_DISCARD = '废弃'

/**
 * 接触轮次 - 首次接触
 */
export const PROP_IIM_INVITATION_ROUNDS_INVITATION_ROUNDS_FIRST = '首次接触'

/**
 * 接触轮次 - 二次接触
 */
export const PROP_IIM_INVITATION_ROUNDS_INVITATION_ROUNDS_TWICE = '二次接触'

/**
 * 接触轮次 - 三次接触
 */
export const PROP_IIM_INVITATION_ROUNDS_INVITATION_ROUNDS_THREE = '三次接触'

/**
 * 接触轮次 - 多次接触
 */
export const PROP_IIM_INVITATION_ROUNDS_INVITATION_ROUNDS_REPEATEDLY = '多次接触'

/**
 * 保险险种 - 交强险
 */
export const PROP_IIM_INSURANCE_INSURANCE_TYPE_FORCE_CODE = '交强险'

/**
 * 保险险种 - 机动车商业保险单
 */
export const PROP_IIM_INSURANCE_INSURANCE_TYPE_BUSINESS_CODE = '机动车商业保险单'

/**
 * 通话状态 - 有效沟通
 */
export const PROP_IIM_CALL_STATUS_VALID_INTERVIEW = '有效沟通'

/**
 * 通话状态 - 未接通
 */
export const PROP_IIM_CALL_STATUS_NOT_INTERVIEWED = '未接通'

/**
 * 通话状态 - 无效电话
 */
export const PROP_IIM_CALL_STATUS_INVALID_CALL = '无效电话'

/**
 * 通话状态 - 无效沟通
 */
export const PROP_IIM_CALL_STATUS_INVALID_INTERVIEW = '无效沟通'

/**
 * 通话状态 - 未拨打
 */
export const PROP_IIM_CALL_STATUS_NOT_DIALED = '未拨打'

/**
 * 通话状态 - 延时邀约
 */
export const PROP_IIM_CALL_STATUS_DELAY_INSURANCE = '延时邀约'

/**
 * 续保状态 - 跟踪
 */
export const PROP_IIM_RENEWAL_OF_INSURANCE_STATUS_CUSTOMER_RELATION_TRACK = '跟踪'

/**
 * 续保状态 - 交商共保
 */
export const PROP_IIM_RENEWAL_OF_INSURANCE_STATUS_CUSTOMER_RELATION_SUCCESS = '交商共保'

/**
 * 续保状态 - 战败
 */
export const PROP_IIM_RENEWAL_OF_INSURANCE_STATUS_CUSTOMER_RELATION_DEFEATED = '战败'

/**
 * 续保状态 - 单交强
 */
export const PROP_IIM_RENEWAL_OF_INSURANCE_STATUS_SINGLE_CROSS_STRONG = '单交强'

/**
 * 续保状态 - 单商业
 */
export const PROP_IIM_RENEWAL_OF_INSURANCE_STATUS_SINGLE_BUSINESS = '单商业'

/**
 * 邀约状态 - 已邀约
 */
export const PROP_IIM_INVITATION_STATUS_INVITATION_STATUS_SUCCESS = '已邀约'

/**
 * 邀约状态 - 未邀约
 */
export const PROP_IIM_INVITATION_STATUS_INVITATION_STATUS_NOT_STARTED = '未邀约'

/**
 * 客户类别 - 新保
 */
export const PROP_IIM_CUSTOMER_TYPE_XINBAO = '新保'

/**
 * 客户类别 - 在修不在保
 */
export const PROP_IIM_CUSTOMER_TYPE_UNDER_REPAIR = '在修不在保'

/**
 * 客户类别 - 不在修不在保
 */
export const PROP_IIM_CUSTOMER_TYPE_NOT_REPAIR = '不在修不在保'

/**
 * 客户类别 - 新转续
 */
export const PROP_IIM_CUSTOMER_TYPE_NEW_RENEWAL = '新转续'

/**
 * 客户类别 - 续转续
 */
export const PROP_IIM_CUSTOMER_TYPE_CONTINUE = '续转续'

/**
 * 客户类别 - 单交强
 */
export const PROP_IIM_CUSTOMER_TYPE_SINGLE_CROSS_STRONG = '单交强'

/**
 * 客户类别 - 单三者
 */
export const PROP_IIM_CUSTOMER_TYPE_SINGLE_THREE = '单三者'

/**
 * 客户类别 - 其他
 */
export const PROP_IIM_CUSTOMER_TYPE_OTHER = '其他'

/**
 * 车型名称 - A1
 */
export const PROP_IIM_VEHICLE_NAME_A1 = 'A1'

/**
 * 车型名称 - S3
 */
export const PROP_IIM_VEHICLE_NAME_S3 = 'S3'

/**
 * 车型名称 - A3
 */
export const PROP_IIM_VEHICLE_NAME_A3 = 'A3'

/**
 * 车型名称 - A4
 */
export const PROP_IIM_VEHICLE_NAME_A4 = 'A4'

/**
 * 车型名称 - A5
 */
export const PROP_IIM_VEHICLE_NAME_A5 = 'A5'

/**
 * 车型名称 - A6
 */
export const PROP_IIM_VEHICLE_NAME_A6 = 'A6'

/**
 * 车型名称 - A7
 */
export const PROP_IIM_VEHICLE_NAME_A7 = 'A7'

/**
 * 车型名称 - A8
 */
export const PROP_IIM_VEHICLE_NAME_A8 = 'A8'

/**
 * 车型名称 - Q2
 */
export const PROP_IIM_VEHICLE_NAME_Q2 = 'Q2'

/**
 * 车型名称 - Q3
 */
export const PROP_IIM_VEHICLE_NAME_Q3 = 'Q3'

/**
 * 车型名称 - Q5
 */
export const PROP_IIM_VEHICLE_NAME_Q5 = 'Q5'

/**
 * 车型名称 - Q5L
 */
export const PROP_IIM_VEHICLE_NAME_Q5L = 'Q5L'

/**
 * 车型名称 - Q7
 */
export const PROP_IIM_VEHICLE_NAME_Q7 = 'Q7'

/**
 * 车型名称 - TT
 */
export const PROP_IIM_VEHICLE_NAME_TT = 'TT'

/**
 * 车型名称 - R8
 */
export const PROP_IIM_VEHICLE_NAME_R8 = 'R8'

/**
 * 车型名称 - XD
 */
export const PROP_IIM_VEHICLE_NAME_XD = 'XD'

/**
 * 客户续保状态 - 已续保
 */
export const PROP_IIM_CALL_STATUS_INSURANCE_STATUS_INSURANCE_NORMAL = '已续保'

/**
 * 客户续保状态 - 未续保
 */
export const PROP_IIM_CALL_STATUS_INSURANCE_STATUS_NOT_INSURANCE_NORMAL = '未续保'

/**
 * 营销活动实例状态 - 已创建
 */
export const PROP_DEMO_MARKETING_ACTIVITY_STATUS_MARKETING_ACTIVITY_STATUS_NORMAL = '已创建'

/**
 * 营销活动实例状态 - 进行中
 */
export const PROP_DEMO_MARKETING_ACTIVITY_STATUS_MARKETING_ACTIVITY_STATUS_PROCESSING = '进行中'

/**
 * 营销活动实例状态 - 已终止
 */
export const PROP_DEMO_MARKETING_ACTIVITY_STATUS_MARKETING_ACTIVITY_STATUS_TERMINATION = '已终止'

/**
 * 营销活动实例状态 - 已完成
 */
export const PROP_DEMO_MARKETING_ACTIVITY_STATUS_MARKETING_ACTIVITY_STATUS_CARRY_OUT = '已完成'

/**
 * 营销活动推荐状态 - 进行中
 */
export const PROP_DEMO_SUGGEST_MARKETING_ACTIVITY_STATUS_SUGGEST_MARKETING_ACTIVITY_STATUS_PROCESSING = '进行中'

/**
 * 营销活动推荐状态 - 已终止
 */
export const PROP_DEMO_SUGGEST_MARKETING_ACTIVITY_STATUS_SUGGEST_MARKETING_ACTIVITY_STATUS_TERMINATION = '已终止'

/**
 * 营销活动推荐计算周期 - 每年
 */
export const PROP_DEMO_SUGGEST_MARKETING_ACTIVITY_CALCULATION_CYCLE_CALCULATION_CYCLE_YEARLY = '每年'

/**
 * 营销活动推荐计算周期 - 每季度
 */
export const PROP_DEMO_SUGGEST_MARKETING_ACTIVITY_CALCULATION_CYCLE_CALCULATION_CYCLE_QUARTERLY = '每季度'

/**
 * 营销活动推荐计算周期 - 每月
 */
export const PROP_DEMO_SUGGEST_MARKETING_ACTIVITY_CALCULATION_CYCLE_CALCULATION_CYCLE_MONTHLY = '每月'

/**
 * 模型活动车辆状态 - 活动进店
 */
export const PROP_DEMO_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_STORE = '活动进店'

/**
 * 模型活动车辆状态 - 活动不进店
 */
export const PROP_DEMO_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_NOT_STORE = '活动不进店'

/**
 * 模型活动车辆状态 - 活动不确定进店
 */
export const PROP_DEMO_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_UNCERTAIN_STORE = '活动不确定进店'

/**
 * 模型日常车辆状态 - 预约进店保养
 */
export const PROP_DEMO_DAILY_VEHICLE_STATUS_RESERVATION_MAINTENANCE = '预约进店保养'

/**
 * 模型日常车辆状态 - 邀约进店保养
 */
export const PROP_DEMO_DAILY_VEHICLE_STATUS_INVITATION_MAINTENANCE = '邀约进店保养'

/**
 * 模型日常车辆状态 - 未到里程500
 */
export const PROP_DEMO_DAILY_VEHICLE_STATUS_LESS_THAN_FIVE_HUNDRED = '未到里程500'

/**
 * 模型日常车辆状态 - 未到里程1000
 */
export const PROP_DEMO_DAILY_VEHICLE_STATUS_LESS_THAN_THOUSAND = '未到里程1000'

/**
 * 模型日常车辆状态 - 未到里程
 */
export const PROP_DEMO_DAILY_VEHICLE_STATUS_LESS_THAN_MILEAGE = '未到里程'

/**
 * 模型日常车辆状态 - 车已流失，放弃
 */
export const PROP_DEMO_DAILY_VEHICLE_STATUS_CAR_LOSS_ABORT = '车已流失，放弃'

/**
 * 模型日常维修类别 - 首保
 */
export const PROP_DEMO_DAILY_MAINTAIN_CATEGORY_0_ = '首保'

/**
 * 模型日常维修类别 - 保养
 */
export const PROP_DEMO_DAILY_MAINTAIN_CATEGORY_2_ = '保养'

/**
 * 保险公司 - 人保
 */
export const PROP_IIM_INSURANCE_COMPANY_INSURER_TYPE_BUSINESS_CODE = '人保'

/**
 * 保险公司 - 平安
 */
export const PROP_IIM_INSURANCE_COMPANY_PINGANINSURANCE_TYPE_BUSINESS_CODE = '平安'

/**
 * 保险公司 - 太平洋
 */
export const PROP_IIM_INSURANCE_COMPANY_CHINAPACIFICINSURANCE_TYPE_BUSINESS_CODE = '太平洋'

/**
 * 保险公司 - 中华联合
 */
export const PROP_IIM_INSURANCE_COMPANY_THECHINESEINSURANCE_TYPE_BUSINESS_CODE = '中华联合'

/**
 * 保险公司 - 人寿
 */
export const PROP_IIM_INSURANCE_COMPANY_THELIFEINSURANCE_TYPE_BUSINESS_CODE = '人寿'

/**
 * 保险公司 - 都邦
 */
export const PROP_IIM_INSURANCE_COMPANY_FORINSURANCE_TYPE_BUSINESS_CODE = '都邦'

/**
 * 保险公司 - 大地
 */
export const PROP_IIM_INSURANCE_COMPANY_GROUNDINSURER_TYPE_BUSINESS_CODE = '大地'

/**
 * 保险公司 - 阳光
 */
export const PROP_IIM_INSURANCE_COMPANY_SUNSHINEINSURANCE_TYPE_BUSINESS_CODE = '阳光'

/**
 * 保险公司 - 天安
 */
export const PROP_IIM_INSURANCE_COMPANY_TIANANINSURANCE_TYPE_BUSINESS_CODE = '天安'

/**
 * 保险公司 - 永安
 */
export const PROP_IIM_INSURANCE_COMPANY_YONGANINSURANCE_TYPE_BUSINESS_CODE = '永安'

/**
 * 保险公司 - 华安
 */
export const PROP_IIM_INSURANCE_COMPANY_HUAANINSURER_TYPE_BUSINESS_CODE = '华安'

/**
 * 保险公司 - 安邦
 */
export const PROP_IIM_INSURANCE_COMPANY_BUSINESSINSURANCE_TYPE_BUSINESS_CODE = '安邦'

/**
 * 保险公司 - 永诚
 */
export const PROP_IIM_INSURANCE_COMPANY_YONGCHENGINSURANCE_TYPE_BUSINESS_CODE = '永诚'

/**
 * 保险公司 - 太平
 */
export const PROP_IIM_INSURANCE_COMPANY_TAIPINGGENERALINSURANCE_TYPE_BUSINESS_CODE = '太平'

/**
 * 保险公司 - 中银
 */
export const PROP_IIM_INSURANCE_COMPANY_BOCINSURANCE_TYPE_BUSINESS_CODE = '中银'

/**
 * 保险公司 - 渤海
 */
export const PROP_IIM_INSURANCE_COMPANY_THEBOHAISEAGENERALINSURANCE_TYPE_BUSINESS_CODE = '渤海'

/**
 * 保险公司 - 亚太
 */
export const PROP_IIM_INSURANCE_COMPANY_ASIAPACIFICINSURANCE_TYPE_BUSINESS_CODE = '亚太'

/**
 * 保险公司 - 安华
 */
export const PROP_IIM_INSURANCE_COMPANY_ANHUAAGRICULTURALINSURANCE_TYPE_BUSINESS_CODE = '安华'

/**
 * 保险公司 - 英大
 */
export const PROP_IIM_INSURANCE_COMPANY_THEBIGTAIHE_TYPE_BUSINESS_CODE = '英大'

/**
 * 保险公司 - 信达
 */
export const PROP_IIM_INSURANCE_COMPANY_CINDAPC_TYPE_BUSINESS_CODE = '信达'

/**
 * 保险公司 - 其他
 */
export const PROP_IIM_INSURANCE_COMPANY_RESTS_TYPE_BUSINESS_CODE = '其他'

/**
 * 保险公司 - 鑫安
 */
export const PROP_IIM_INSURANCE_COMPANY_XINAN_BUSINESS_CODE = '鑫安'

/**
 * 子险种类别主险 - 车损险
 */
export const PROP_IIM_SON_INSURANCE_MAIN_CARDAMAGEINSURANCE_TYPE_BUSINESS_CODE = '车损险'

/**
 * 子险种类别主险 - 第三者责任险
 */
export const PROP_IIM_SON_INSURANCE_MAIN_THIRDPARTY_TYPE_BUSINESS_CODE = '第三者责任险'

/**
 * 子险种类别主险 - 车上司机险
 */
export const PROP_IIM_SON_INSURANCE_MAIN_DRIVER_TYPE_BUSINESS_CODE = '车上司机险'

/**
 * 子险种类别主险 - 车上乘客险
 */
export const PROP_IIM_SON_INSURANCE_MAIN_PASSENGER_TYPE_BUSINESS_CODE = '车上乘客险'

/**
 * 子险种类别主险 - 全车盗抢险
 */
export const PROP_IIM_SON_INSURANCE_MAIN_ALLCARTHEFT_TYPE_BUSINESS_CODE = '全车盗抢险'

/**
 * 子险种类别附加险 - 车身划痕险
 */
export const PROP_IIM_SON_INSURANCE_ATTACH_BODYSCRATCHES_TYPE_BUSINESS_CODE = '车身划痕险'

/**
 * 子险种类别附加险 - 玻璃破碎险
 */
export const PROP_IIM_SON_INSURANCE_ATTACH_GLASS_TYPE_BUSINESS_CODE = '玻璃破碎险'

/**
 * 子险种类别附加险 - 自燃损失险
 */
export const PROP_IIM_SON_INSURANCE_ATTACH_NATURE_TYPE_BUSINESS_CODE = '自燃损失险'

/**
 * 子险种类别附加险 - 涉水险
 */
export const PROP_IIM_SON_INSURANCE_ATTACH_WADING_TYPE_BUSINESS_CODE = '涉水险'

/**
 * 子险种类别附加险 - 车损无第三方
 */
export const PROP_IIM_SON_INSURANCE_ATTACH_NOTHIRDPARTYINDAMAGE_TYPE_BUSINESS_CODE = '车损无第三方'

/**
 * 商业子险种类别 - 主险
 */
export const PROP__IIM_BRANCH_OF_INSURANCE_MAIN_INSURANCE_TYPE_BUSINESS_CODE = '主险'

/**
 * 商业子险种类别 - 附加险
 */
export const PROP__IIM_BRANCH_OF_INSURANCE_ATTACH_INSURANCE_TYPE_BUSINESS_CODE = '附加险'

/**
 * 年度任务名称 - 延保销量
 */
export const PROP_CSM_TASK_NAME_EXTENDED_WARRANTY_SALES = '延保销量'

/**
 * 年度任务名称 - 会员销量
 */
export const PROP_CSM_TASK_NAME_MEMBER_SALES = '会员销量'

/**
 * 年度任务名称 - 套餐销量
 */
export const PROP_CSM_TASK_NAME_SET_OF_RUB_SALES = '套餐销量'

/**
 * 年度任务名称 - 续保销量
 */
export const PROP_CSM_TASK_NAME_RENEWAL_SALES = '续保销量'

/**
 * 客户意见 - 服务人员态度不友好/不礼貌
 */
export const PROP_CSR_CUSTOMER_OPINION_SERVICE_STAFF_ATTITUDE_IS_NOT_FRIENDLY_IMPOLITE = '服务人员态度不友好/不礼貌'

/**
 * 客户意见 - 服务人员不可靠（不遵守承诺/欺骗用户）
 */
export const PROP_CSR_CUSTOMER_OPINION_SERVICE_PERSONNEL_ARE_UNRELIABLE_NOT_COMPLYING_WITH_PROMISES__DECEIVING_USERS = '服务人员不可靠（不遵守承诺/欺骗用户）'

/**
 * 客户意见 - 不能有求必应/不耐心倾听您的要求并给予回应
 */
export const PROP_CSR_CUSTOMER_OPINION_CAN_N0T_BE_RESPONSIVE__IMPATIENT_TO_LISTEN_TO_YOUR_REQUEST_AND_RESPOND = '不能有求必应/不耐心倾听您的要求并给予回应'

/**
 * 客户意见 - 车辆维修/保养的工作内容解释不到位/不专业
 */
export const PROP_CSR_CUSTOMER_OPINION_THE_WORK_CONTENT_OF_VEHICLE_REPAIR_MAINTENANCE_IS_NOT_EXPLAINED_UNPROFESSIONAL = '车辆维修/保养的工作内容解释不到位/不专业'

/**
 * 客户意见 - 服务站无人接待
 */
export const PROP_CSR_CUSTOMER_OPINION_SERVICE_STATION_NO_RECEPTION = '服务站无人接待'

/**
 * 客户意见 - 取车时无人协助
 */
export const PROP_CSR_CUSTOMER_OPINION_NO_ASSISTANCE_WHEN_PICKING_UP_THE_CAR = '取车时无人协助'

/**
 * 客户意见 - 服务站拒绝维修/拒绝服务
 */
export const PROP_CSR_CUSTOMER_OPINION_SERVICE_STATION_REFUSED_TO_REPAIR__REFUSE_SERVICE = '服务站拒绝维修/拒绝服务'

/**
 * 客户意见 - 服务站未征得用户同意进行维修/保养
 */
export const PROP_CSR_CUSTOMER_OPINION_THE_SERVICE_STATION_DID_NOT_OBTAIN_THE_USER_S_CONSENT_FOR_REPAIR_MAINTENANCE = '服务站未征得用户同意进行维修/保养'

/**
 * 客户意见 - 服务人员服务建议不合理/质量不高
 */
export const PROP_CSR_CUSTOMER_OPINION_SERVICE_PERSONNEL_SERVICE_ADVICE_IS_UNREASONABLE_QUALITY_IS_NOT_HIGH = '服务人员服务建议不合理/质量不高'

/**
 * 客户意见 - 服务站强行推销服务
 */
export const PROP_CSR_CUSTOMER_OPINION_SERVICE_STATION_FORCIBLE_MARKETING_SERVICE = '服务站强行推销服务'

/**
 * 客户意见 - 服务站不提供发票等文件/手续
 */
export const PROP_CSR_CUSTOMER_OPINION_THE_SERVICE_STATION_DOES_NOT_PROVIDE_INVOICES_AND_OTHER_DOCUMENTS_PROCEDURES = '服务站不提供发票等文件/手续'

/**
 * 客户意见 - 服务站不让进入维修车间/不让接触维修人员
 */
export const PROP_CSR_CUSTOMER_OPINION_SERVICE_STATION_DOES_NOT_ALLOW_ACCESS_TO_THE_REPAIR_SHOP__NO_CONTACT_WITH_MAINTENANCE_PERSONNEL = '服务站不让进入维修车间/不让接触维修人员'

/**
 * 客户意见 - 服务站没有及时跟进/告知维修/保养的进度
 */
export const PROP_CSR_CUSTOMER_OPINION_THE_SERVICE_STATION_DID_NOT_FOLLOW_UP_IN_TIME_INFORMED_OF_THE_PROGRESS_OF_REPAIR__MAINTENANCE = '服务站没有及时跟进/告知维修/保养的进度'

/**
 * 客户意见 - 14维修后无人联系/长时间无人联系
 */
export const PROP_CSR_CUSTOMER_OPINION_NO_CONTACT_AFTER_14_MAINTENANCE__NO_CONTACT_FOR_A_LONG_TIME = '14维修后无人联系/长时间无人联系'

/**
 * 客户意见 - 15.电话回访方式不妥/希望有其他的回访形式
 */
export const PROP_CSR_CUSTOMER_OPINION_THE_WAY_TO_RETURN_TO_THE_PHONE_IS_NOT_APPROPRIATE__I_HOPE_THERE_ARE_OTHER_FORMS_OF_RETURNING = '15.电话回访方式不妥/希望有其他的回访形式'

/**
 * 客户意见 - O2.1未介绍替代交通服务内容内容
 */
export const PROP_CSR_CUSTOMER_OPINION_NO_ALTERNATIVE_TRANSPORTATION_SERVICE_CONTENT_IS_INTRODUCED = 'O2.1未介绍替代交通服务内容内容'

/**
 * 客户意见 - O2.2未提供替代交通服务项目
 */
export const PROP_CSR_CUSTOMER_OPINION_NO_ALTERNATIVE_TRANSPORTATION_SERVICE_PROVIDED = 'O2.2未提供替代交通服务项目'

/**
 * 客户意见 - O2.3替代交通服务收费不合理/价格高
 */
export const PROP_CSR_CUSTOMER_OPINION_ALTERNATIVE_TRANSPORTATION_SERVICE_CHARGES_ARE_UNREASONABLE_AND_HIGH_PRICE = 'O2.3替代交通服务收费不合理/价格高'

/**
 * 客户意见 - O2.4提供的替代交通服务方式不满意（打车费少/提供车型配置低等)
 */
export const PROP_CSR_CUSTOMER_OPINION_DISSATISFIED_WITH_THE_ALTERNATIVE_TRANSPORTATION_SERVICE_PROVIDED = 'O2.4提供的替代交通服务方式不满意（打车费少/提供车型配置低等)'

/**
 * 客户意见 - O3.1工时费价格高
 */
export const PROP_CSR_CUSTOMER_OPINION_HIGH_WORKING_HOURS = 'O3.1工时费价格高'

/**
 * 客户意见 - O3.2备件价格高
 */
export const PROP_CSR_CUSTOMER_OPINION_HIGH_SPARE_PARTS_PRICES = 'O3.2备件价格高'

/**
 * 客户意见 - O3.3保养价格高
 */
export const PROP_CSR_CUSTOMER_OPINION_HIGH_MAINTENANCE_PRICE = 'O3.3保养价格高'

/**
 * 客户意见 - O3.4维修价格高
 */
export const PROP_CSR_CUSTOMER_OPINION_HIGH_MAINTENANCE_PRICE_SERVICE = 'O3.4维修价格高'

/**
 * 客户意见 - O3.5维修前未明确告知预计的维修/保养价格
 */
export const PROP_CSR_CUSTOMER_OPINION_UNEXPECTED_REPAIR_AND_MAINTENANCE_PRICE_IS_NOT_CLEARLY_STATED_BEFORE_REPAIR = 'O3.5维修前未明确告知预计的维修/保养价格'

/**
 * 客户意见 - O3.6服务项目及价格清单未能详尽地给予解释
 */
export const PROP_CSR_CUSTOMER_OPINION_SERVICE_ITEMS_AND_PRICE_LISTS_ARE_NOT_EXPLAINED_IN_DETAIL = 'O3.6服务项目及价格清单未能详尽地给予解释'

/**
 * 客户意见 - O3.7保养/维修后的实际价格较预估价格变化较大/预估不准确
 */
export const PROP_CSR_CUSTOMER_OPINION_THE_ACTUAL_PRICE_AFTER_MAINTENANCE_AND_REPAIR_IS_LARGER_THAN_THE_ESTIMATED_PRICE_AND_PREDICTED_INACCURATE = 'O3.7保养/维修后的实际价格较预估价格变化较大/预估不准确'

/**
 * 客户意见 - O3.8服务收费不合理（收取不应有的费用）
 */
export const PROP_CSR_CUSTOMER_OPINION_SERVICE_CHARGES_ARE_UNREASONABLE = 'O3.8服务收费不合理（收取不应有的费用）'

/**
 * 客户意见 - O4.1不能按照希望的时间进行预约
 */
export const PROP_CSR_CUSTOMER_OPINION_CA_NOT_MAKE_AN_APPOINTMENT_AT_THE_DESIRED_TIME = 'O4.1不能按照希望的时间进行预约'

/**
 * 客户意见 - O4.2预约时间长
 */
export const PROP_CSR_CUSTOMER_OPINION_LONG_APPOINTMENT_TIME = 'O4.2预约时间长'

/**
 * 客户意见 - O4.3送车时等待时间长
 */
export const PROP_CSR_CUSTOMER_OPINION_LONG_WAITING_TIME_WHEN_SENDING_A_CAR = 'O4.3送车时等待时间长'

/**
 * 客户意见 - O4.4保养时间长
 */
export const PROP_CSR_CUSTOMER_OPINION_LONG_MAINTENANCE_TIME = 'O4.4保养时间长'

/**
 * 客户意见 - O4.5维修时间长
 */
export const PROP_CSR_CUSTOMER_OPINION_LONG_MAINTENANCE_TIME__SERVICE = 'O4.5维修时间长'

/**
 * 客户意见 - O4.6备件等待时间长
 */
export const PROP_CSR_CUSTOMER_OPINION_LONG_WAITING_TIME_FOR_SPARE_PARTS = 'O4.6备件等待时间长'

/**
 * 客户意见 - O4.7维修/保养时间超出了承诺时间/不能按时交接车辆
 */
export const PROP_CSR_CUSTOMER_OPINION_REPAIR_AND_MAINTENANCE_TIME_EXCEEDS_PROMISED_TIME_AND_CANNOT_DELIVER_VEHICLE_ON_TIME = 'O4.7维修/保养时间超出了承诺时间/不能按时交接车辆'

/**
 * 客户意见 - O4.8救援时间长
 */
export const PROP_CSR_CUSTOMER_OPINION_LONG_RESCUE_TIME = 'O4.8救援时间长'

/**
 * 客户意见 - O4.9保险办理时间长
 */
export const PROP_CSR_CUSTOMER_OPINION_LONG_INSURANCE_PROCESSING_TIME = 'O4.9保险办理时间长'

/**
 * 客户意见 - O4.10手续办理及交接时间长（填写单据、签字等环节）
 */
export const PROP_CSR_CUSTOMER_OPINION_LONG_PROCEDURE_AND_HANDOVER_TIME = 'O4.10手续办理及交接时间长（填写单据、签字等环节）'

/**
 * 客户意见 - O4.11取车时等待时间长
 */
export const PROP_CSR_CUSTOMER_OPINION_LONG_WAITING_TIME_WHEN_PICKING_UP_THE_CAR = 'O4.11取车时等待时间长'

/**
 * 客户意见 - O4.12洗车时间长
 */
export const PROP_CSR_CUSTOMER_OPINION_LONG_CAR_WASH_TIME = 'O4.12洗车时间长'

/**
 * 客户意见 - O5.1车辆故障检测不出来/诊断有误
 */
export const PROP_CSR_CUSTOMER_OPINION_VEHICLE_FAILURE_DETECTION_IS_NOT_DETECTED_AND_DIAGNOSIS_IS_INCORRECT = 'O5.1车辆故障检测不出来/诊断有误'

/**
 * 客户意见 - O5.2维修/保养不彻底/故障未解决
 */
export const PROP_CSR_CUSTOMER_OPINION_REPAIR_AND_MAINTENANCE_IS_NOT_COMPLETE_AND_FAULT_IS_NOT_RESOLVED = 'O5.2维修/保养不彻底/故障未解决'

/**
 * 客户意见 - O5.2维修/保养车辆被返修/重修
 */
export const PROP_CSR_CUSTOMER_OPINION_REPAIR_MAINTENANCE_IS_NOT_COMPLETE_FAULT_IS_NOT_RESOLVED = 'O5.2维修/保养车辆被返修/重修'

/**
 * 客户意见 - O5.3保养/维修后的车辆不干净/不整洁
 */
export const PROP_CSR_CUSTOMER_OPINION_MAINTENANCE_AND_REPAIR_OF_THE_VEHICLE_IS_NOT_CLEAN_AND_UNTIDY = 'O5.3保养/维修后的车辆不干净/不整洁'

/**
 * 客户意见 - O5.4维修/保养后车辆出现新故障
 */
export const PROP_CSR_CUSTOMER_OPINION_NEW_FAULT_IN_THE_VEHICLE_AFTER_REPAIR_AND_MAINTENANCE = 'O5.4维修/保养后车辆出现新故障'

/**
 * 客户意见 - O5.5服务人员维修/保养工作不专业
 */
export const PROP_CSR_CUSTOMER_OPINION_SERVICE_PERSONNEL_REPAIR_AND_MAINTENANCE_WORK_IS_NOT_PROFESSIONAL = 'O5.5服务人员维修/保养工作不专业'

/**
 * 客户意见 - O5.6维修/保养后车辆在站内被使用/损坏/改变车辆设置
 */
export const PROP_CSR_CUSTOMER_OPINION_VEHICLE_USED_AND_DAMAGED_AND_CHANGED_VEHICLE_SETTINGS_AFTER_REPAIR_AND_MAINTENANCE = 'O5.6维修/保养后车辆在站内被使用/损坏/改变车辆设置'

/**
 * 客户意见 - O5.7未能完成要求的项目
 */
export const PROP_CSR_CUSTOMER_OPINION_FAILED_TO_COMPLETE_THE_REQUESTED_PROJECT = 'O5.7未能完成要求的项目'

/**
 * 客户意见 - O5.8维修/保养方案不合理
 */
export const PROP_CSR_CUSTOMER_OPINION_REPAIR_AND_MAINTENANCE_PLAN_IS_UNREASONABLE = 'O5.8维修/保养方案不合理'

/**
 * 客户意见 - O6.1地理位置不便利
 */
export const PROP_CSR_CUSTOMER_OPINION_LOCATION_IS_NOT_CONVENIENT = 'O6.1地理位置不便利'

/**
 * 客户意见 - O6.2进出经销店不方便
 */
export const PROP_CSR_CUSTOMER_OPINION_IS_INCONVENIENT_TO_ENTER_AND_EXIT_THE_DEALERSHIP = 'O6.2进出经销店不方便'

/**
 * 客户意见 - O6.3车辆在服务站停放不方便
 */
export const PROP_CSR_CUSTOMER_OPINION_VEHICLES_ARE_NOT_CONVENIENT_TO_PARK_AT_THE_SERVICE_STATION = 'O6.3车辆在服务站停放不方便'

/**
 * 客户意见 - O6.3客户休息区环境不舒适/设施不齐全
 */
export const PROP_CSR_CUSTOMER_OPINION_CUSTOMER_LOUNGE_AREA_IS_NOT_COMFORTABLE_AND_FACILITIES_ARE_NOT_COMPLETE = 'O6.3客户休息区环境不舒适/设施不齐全'

/**
 * 客户意见 - O6.4维修站的食物/饮品不满意
 */
export const PROP_CSR_CUSTOMER_OPINION_REPAIR_STATION_FOOD_AND_DRINK_IS_NOT_SATISFIED = 'O6.4维修站的食物/饮品不满意'

/**
 * 客户意见 - O6.5整体环境设施不干净
 */
export const PROP_CSR_CUSTOMER_OPINION_OVERALL_ENVIRONMENTAL_FACILITIES_ARE_NOT_CLEAN = 'O6.5整体环境设施不干净'

/**
 * 客户意见 - 7.1财务
 */
export const PROP_CSR_CUSTOMER_OPINION_FINANCE = '7.1财务'

/**
 * 客户意见 - 7.2食堂
 */
export const PROP_CSR_CUSTOMER_OPINION_CANTEEN = '7.2食堂'

/**
 * 回访状态 - 空号
 */
export const PROP_CSR_ACCESS_PHONE_STATUS_EMPTY_NUMBER = '空号'

/**
 * 回访状态 - 挂断
 */
export const PROP_CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_HANG_UP = '挂断'

/**
 * 回访状态 - 关机
 */
export const PROP_CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_SHUT_DOWN = '关机'

/**
 * 回访状态 - 拒访
 */
export const PROP_CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_REFUSAL = '拒访'

/**
 * 回访状态 - 时间不宜
 */
export const PROP_CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_TIME_IS_NOT_APPROPRIATE = '时间不宜'

/**
 * 回访状态 - 停机
 */
export const PROP_CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_DOWNTIME = '停机'

/**
 * 回访状态 - 无法接通
 */
export const PROP_CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_UNABLE_TO_CONNECT = '无法接通'

/**
 * 回访状态 - 无人接听
 */
export const PROP_CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_NO_ONE_HEARD = '无人接听'

/**
 * 回访状态 - 占线
 */
export const PROP_CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_BUSY = '占线'

/**
 * 销售类型 - 成功
 */
export const PROP_CSM_PACKAGE_SALE_TYPE_SALE_MAINTAIN_PACKAGE = '成功'

/**
 * 销售类型 - 战败
 */
export const PROP_CSM_PACKAGE_SALE_TYPE_SALE_FAIL_PACKAGE = '战败'

/**
 * 备件状态 - 正常
 */
export const PROP_CSM_PARTS_STATUS_PARTS_STATUS_NORMAL = '正常'

/**
 * 备件状态 - 订件
 */
export const PROP_CSM_PARTS_STATUS_PARTS_STATUS_ORDER = '订件'

/**
 * 备件状态 - 到货
 */
export const PROP_CSM_PARTS_STATUS_PARTS_STATUS_ARRIVAL = '到货'

/**
 * 是否有效 - 有效
 */
export const PROP_UCT_VALIDITY_VALID = '有效'

/**
 * 是否有效 - 无效
 */
export const PROP_UCT_VALIDITY_INVALID = '无效'

/**
 * 商机阶段 - 二次洽谈
 */
export const PROP_UCT_CARRIED_OUT_STATUS_SECOND_NEGOTIATION = '二次洽谈'

/**
 * 商机阶段 - 三次洽谈
 */
export const PROP_UCT_CARRIED_OUT_STATUS_THREE_TALKS = '三次洽谈'

/**
 * 商机阶段 - 多次洽谈
 */
export const PROP_UCT_CARRIED_OUT_STATUS_NEGOTIATE_MANY_TIMES = '多次洽谈'

/**
 * 商机阶段 - 成单
 */
export const PROP_UCT_CARRIED_OUT_STATUS_INTO_A_SINGLE = '成单'

/**
 * 商机阶段 - 战败
 */
export const PROP_UCT_CARRIED_OUT_STATUS_DEFEATED = '战败'

/**
 * 商机类型 - 换购
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_TYPE_REDEMPTION = '换购'

/**
 * 商机类型 - 收购
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_TYPE_ACQUISITION = '收购'

/**
 * 商机类型 - 售车
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_TYPE_CAR_SALES = '售车'

/**
 * 商机来源 - 售后
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_SOURCE_AFTER_SALE = '售后'

/**
 * 商机来源 - 展厅
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_SOURCE_SHOWROOM = '展厅'

/**
 * 商机来源 - 网络
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_SOURCE_THE_INTERNET = '网络'

/**
 * 商机来源 - 社会
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_SOURCE_SOCIETY = '社会'

/**
 * 车身颜色 - 黑色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_BLACK = '黑色'

/**
 * 车身颜色 - 白色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_WHITE = '白色'

/**
 * 车身颜色 - 银灰色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_SILVER_GREY = '银灰色'

/**
 * 车身颜色 - 深灰色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_DARK_GRAY = '深灰色'

/**
 * 车身颜色 - 红色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_RED = '红色'

/**
 * 车身颜色 - 蓝色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_BLUE = '蓝色'

/**
 * 车身颜色 - 绿色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_GREEN = '绿色'

/**
 * 车身颜色 - 黄色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_YELLOW = '黄色'

/**
 * 车身颜色 - 香槟色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_CHAMPAGNE = '香槟色'

/**
 * 车身颜色 - 紫色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_PURPLE = '紫色'

/**
 * 车身颜色 - 橙色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_ORANGE = '橙色'

/**
 * 车身颜色 - 棕色
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_BROWN = '棕色'

/**
 * 车身颜色 - 其他
 */
export const PROP_UCT_CURRENT_THE_COLOR_OF_CAR_OTHER = '其他'

/**
 * 燃油类型 - 汽油
 */
export const PROP_UCT_FUEL_TYPE_GASOLINE = '汽油'

/**
 * 燃油类型 - 柴油
 */
export const PROP_UCT_FUEL_TYPE_DIESEL = '柴油'

/**
 * 燃油类型 - 混动
 */
export const PROP_UCT_FUEL_TYPE_HYBRID = '混动'

/**
 * 燃油类型 - 电动
 */
export const PROP_UCT_FUEL_TYPE_ELECTRIC = '电动'

/**
 * 排放标准 - 国II
 */
export const PROP_UCT_CURRENT_EMISSION_STANDARDS_COUNTRY_TWO = '国II'

/**
 * 排放标准 - 国III
 */
export const PROP_UCT_CURRENT_EMISSION_STANDARDS_COUNTRY_THREE = '国III'

/**
 * 排放标准 - 国IV
 */
export const PROP_UCT_CURRENT_EMISSION_STANDARDS_COUNTRY_FOUR = '国IV'

/**
 * 排放标准 - 国V
 */
export const PROP_UCT_CURRENT_EMISSION_STANDARDS_COUNTRY_FIVES = '国V'

/**
 * 排放标准 - 国VI
 */
export const PROP_UCT_CURRENT_EMISSION_STANDARDS_COUNTRY_SIX = '国VI'

/**
 * 排放标准 - 欧II
 */
export const PROP_UCT_CURRENT_EMISSION_STANDARDS_EURO_TWO = '欧II'

/**
 * 排放标准 - 欧III
 */
export const PROP_UCT_CURRENT_EMISSION_STANDARDS_EURO_THREE = '欧III'

/**
 * 排放标准 - 欧IV
 */
export const PROP_UCT_CURRENT_EMISSION_STANDARDS_EURO_FOUR = '欧IV'

/**
 * 排放标准 - 欧V
 */
export const PROP_UCT_CURRENT_EMISSION_STANDARDS_EURO_FIVES = '欧V'

/**
 * 排放标准 - 欧VI
 */
export const PROP_UCT_CURRENT_EMISSION_STANDARDS_EURO_SIX = '欧VI'

/**
 * 驱动方式 - 前驱
 */
export const PROP_UCT_CURRENT_DRIVING_METHOD_PRECURSOR = '前驱'

/**
 * 驱动方式 - 后驱
 */
export const PROP_UCT_CURRENT_DRIVING_METHOD_REAR_DRIVE = '后驱'

/**
 * 驱动方式 - 四驱
 */
export const PROP_UCT_CURRENT_DRIVING_METHOD_FOUR_WHEEL_DRIVE = '四驱'

/**
 * 通话状态 - 有效沟通
 */
export const PROP_UCT_CALL_STATUS_VALID_INTERVIEW = '有效沟通'

/**
 * 通话状态 - 无效沟通
 */
export const PROP_UCT_CALL_STATUS_INVALID_INTERVIEW = '无效沟通'

/**
 * 线索状态 - 跟踪
 */
export const PROP_UCT_CLUE_STATUS_TRACK = '跟踪'

/**
 * 线索状态 - 成功
 */
export const PROP_UCT_CLUE_STATUS_SUCCESS = '成功'

/**
 * 线索状态 - 战败
 */
export const PROP_UCT_CLUE_STATUS_DEFEATED = '战败'

/**
 * 战败原因 - 车主不想卖
 */
export const PROP_UCT_REASON_FOR_FAILURE_CAR_OWNERS_DO_NOT_WANT_TO_SELL = '车主不想卖'

/**
 * 战败原因 - 车已卖
 */
export const PROP_UCT_REASON_FOR_FAILURE_CAR_SOLD = '车已卖'

/**
 * 商机状态 - 待确认
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_STATUS_TO_BE_CONFIRMED = '待确认'

/**
 * 商机状态 - 已确认
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_STATUS_CONFIRMED = '已确认'

/**
 * 商机状态 - 有效
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_STATUS_EFFECTIVE = '有效'

/**
 * 商机状态 - 无效
 */
export const PROP_UCT_COMMERCIAL_OPPORTUNITY_STATUS_INVALID = '无效'

/**
 * 商机执行状态 - 待执行
 */
export const PROP_UCT_OPPORTUNITY_EXECUTION_STATUS_PENDING = '待执行'

/**
 * 商机执行状态 - 已完成
 */
export const PROP_UCT_OPPORTUNITY_EXECUTION_STATUS_COMPLETED = '已完成'

/**
 * 商机执行状态 - 超期
 */
export const PROP_UCT_OPPORTUNITY_EXECUTION_STATUS_OVERDUE = '超期'

/**
 * 变速箱 - 手动
 */
export const PROP_UCT_CEARBOX_MANUAL = '手动'

/**
 * 变速箱 - 自动
 */
export const PROP_UCT_CEARBOX_AUTOMATIC = '自动'

/**
 * 精品活动战败原因 - 不需要
 */
export const PROP_CSM_REASONS_FOR_DEFEAT_IN_BOUTIQUE_ACTIVITIES_NO_NEED = '不需要'

/**
 * 精品活动战败原因 - 已经安装
 */
export const PROP_CSM_REASONS_FOR_DEFEAT_IN_BOUTIQUE_ACTIVITIES_ALREADY_INSTALLED = '已经安装'

/**
 * 精品活动战败原因 - 价格高
 */
export const PROP_CSM_REASONS_FOR_DEFEAT_IN_BOUTIQUE_ACTIVITIES_HIGH_PRICE = '价格高'

/**
 * 续保战败原因 - 外地车
 */
export const PROP_CAUSE_OF_DEFEAT_FIELD_CAR = '外地车'

/**
 * 续保战败原因 - 已过户
 */
export const PROP_CAUSE_OF_DEFEAT_TRANSFERRED = '已过户'

/**
 * 续保战败原因 - 承保限制
 */
export const PROP_CAUSE_OF_DEFEAT_COVERAGE_RESTRICTIONS = '承保限制'

/**
 * 续保战败原因 - 电话有误
 */
export const PROP_CAUSE_OF_DEFEAT_WRONG_CALL = '电话有误'

/**
 * 续保战败原因 - 明确拒保
 */
export const PROP_CAUSE_OF_DEFEAT_EXPRESS_DENIAL = '明确拒保'

/**
 * 续保战败原因 - 同城价格
 */
export const PROP_CAUSE_OF_DEFEAT_SAME_CITY_PRICE = '同城价格'

/**
 * 续保战败原因 - 人情保
 */
export const PROP_CAUSE_OF_DEFEAT_HUMAN_SECURITY = '人情保'

/**
 * 续保战败原因 - 其他
 */
export const PROP_CAUSE_OF_DEFEAT_OTHER = '其他'

/**
 * 续保战败原因 - 已投保
 */
export const PROP_CAUSE_OF_DEFEAT_INSURED = '已投保'

/**
 * 续保战败原因 - 壁虎无法算价
 */
export const PROP_CAUSE_OF_DEFEAT_GECKO_CAN_NOT_COUNT = '壁虎无法算价'

/**
 * 续保战败原因 - 同城代理
 */
export const PROP_CAUSE_OF_DEFEAT_CITY_AGENT = '同城代理'

/**
 * 续保战败原因 - 同城电销
 */
export const PROP_CAUSE_OF_DEFEAT_TELEMARKETING_IN_THE_SAME_CITY = '同城电销'

/**
 * 续保战败原因 - 同城4S店
 */
export const PROP_CAUSE_OF_DEFEAT_4S_SHOP_IN_THE_SAME_CITY = '同城4S店'

/**
 * 续保战败原因 - 同城业务大厅
 */
export const PROP_CAUSE_OF_DEFEAT_CITY_HALL = '同城业务大厅'

/**
 * 续保战败原因 - 不告诉价格原因
 */
export const PROP_CAUSE_OF_DEFEAT_DO_NOT_TELL_THE_PRICE_REASON = '不告诉价格原因'

/**
 * 续保战败原因 - 省内非吉A牌
 */
export const PROP_CAUSE_OF_DEFEAT_FEIJI_A_BRAND_IN_THE_PROVINCE = '省内非吉A牌'

/**
 * 续保战败原因 - 省外牌
 */
export const PROP_CAUSE_OF_DEFEAT_PROVINCIAL_BRAND = '省外牌'

/**
 * 续保战败原因 - 车龄超10年
 */
export const PROP_CAUSE_OF_DEFEAT_10_YEARS_OLD = '车龄超10年'

/**
 * 客户类别 - A类客户
 */
export const PROP_CSM_CUSTOMER_TYPE_A = 'A类客户'

/**
 * 客户类别 - B类客户
 */
export const PROP_CSM_CUSTOMER_TYPE_B = 'B类客户'

/**
 * 客户类别 - C类客户
 */
export const PROP_CSM_CUSTOMER_TYPE_C = 'C类客户'

/**
 * 客户类别 - D类客户
 */
export const PROP_CSM_CUSTOMER_TYPE_D = 'D类客户'

/**
 * 新增客户类别 - 他店新增
 */
export const PROP_CSM_ADD_CUSTOMER_TYPE_ADDED_IN_OTHER_STORES = '他店新增'

/**
 * 新增客户类别 - 销售新增
 */
export const PROP_CSM_ADD_CUSTOMER_TYPE_NEW_SALES = '销售新增'

/**
 * 新增客户类别 - 流失挽回
 */
export const PROP_CSM_ADD_CUSTOMER_TYPE_CHURN = '流失挽回'

/**
 * 新增客户类别 - 外来客户
 */
export const PROP_CSM_ADD_CUSTOMER_TYPE_FOREIGN_CUSTOMERS = '外来客户'

/**
 * 购车日期按月查询条件 - 1月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_JANUARY = '1月'

/**
 * 购车日期按月查询条件 - 2月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_FEBRUARY = '2月'

/**
 * 购车日期按月查询条件 - 3月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_MARCH = '3月'

/**
 * 购车日期按月查询条件 - 4月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_APRIL = '4月'

/**
 * 购车日期按月查询条件 - 5月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_MAY = '5月'

/**
 * 购车日期按月查询条件 - 6月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_JUNE = '6月'

/**
 * 购车日期按月查询条件 - 7月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_JULY = '7月'

/**
 * 购车日期按月查询条件 - 8月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_AUGUST = '8月'

/**
 * 购车日期按月查询条件 - 9月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_SEPTEMBER = '9月'

/**
 * 购车日期按月查询条件 - 10月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_OCTOBER = '10月'

/**
 * 购车日期按月查询条件 - 11月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_NOVEMBER = '11月'

/**
 * 购车日期按月查询条件 - 12月
 */
export const PROP_DATE_OF_PURCHASE_BY_MONTH_DECEMBER = '12月'

/**
 * 销售状态 - 待跟踪
 */
export const PROP_IIM_LAST_SALE_STATUS_CUSTOMER_RELATION_TRACK = '待跟踪'

/**
 * 销售状态 - 交商共保
 */
export const PROP_IIM_LAST_SALE_STATUS_CUSTOMER_RELATION_SUCCESS = '交商共保'

/**
 * 销售状态 - 战败
 */
export const PROP_IIM_LAST_SALE_STATUS_CUSTOMER_RELATION_DEFEATED = '战败'

/**
 * 销售状态 - 单交强
 */
export const PROP_IIM_LAST_SALE_STATUS_SINGLE_CROSS_STRONG = '单交强'

/**
 * 销售状态 - 单商业
 */
export const PROP_IIM_LAST_SALE_STATUS_SINGLE_BUSINESS = '单商业'

/**
 * 日志类型 - 通话
 */
export const PROP_IIM_TYPE_CALL = '通话'

/**
 * 日志类型 - 分配
 */
export const PROP_IIM_TYPE_DISTRIBUTION = '分配'

/**
 * 沟通事项 - 提醒进店
 */
export const PROP_CSM_COMMUNICATION_MATTERS_REMIND_TO_ENTER_THE_STORE = '提醒进店'

/**
 * 沟通事项 - 销售PLUS
 */
export const PROP_CSM_COMMUNICATION_MATTERS_SALE_PLUS = '销售PLUS'

/**
 * 沟通事项 - 到期提醒
 */
export const PROP_CSM_COMMUNICATION_MATTERS_EXPIRATION_REMINDER = '到期提醒'

/**
 * 延保状态 - 待提醒
 */
export const PROP_CSM_EXTENSION_STATUS_TO_BE_REMINDED = '待提醒'

/**
 * 延保状态 - 提醒中
 */
export const PROP_CSM_EXTENSION_STATUS_REMINDING = '提醒中'

/**
 * 延保状态 - 已终止
 */
export const PROP_CSM_EXTENSION_STATUS_TERMINATED = '已终止'

/**
 * 延保状态 - 已索赔
 */
export const PROP_CSM_EXTENSION_STATUS_CLAIMED = '已索赔'

/**
 * 问卷类型 - 保养
 */
export const PROP_SURVEY_PAGER_TYPE_MAINTENANCE = '保养'

/**
 * 问卷类型 - 首保
 */
export const PROP_SURVEY_PAGER_TYPE_FIRST_GUARANTEE = '首保'

/**
 * 问卷类型 - 事故
 */
export const PROP_SURVEY_PAGER_TYPE_ACCIDENT = '事故'

/**
 * 问卷类型 - 潜客
 */
export const PROP_SURVEY_PAGER_TYPE_POTENTIAL_CUSTOMER = '潜客'

/**
 * 问题类型 - 单选
 */
export const PROP_SURVEY_OPTION_TYPE_RADIO = '单选'

/**
 * 问题类型 - 多选
 */
export const PROP_SURVEY_OPTION_TYPE_MULTIPLE_CHOICE = '多选'

/**
 * 问题类型 - 填空题
 */
export const PROP_SURVEY_OPTION_TYPE_FILL_IN_THE_BLANKS = '填空题'

/**
 * 问题类型 - 问答题
 */
export const PROP_SURVEY_OPTION_TYPE_QUESTIONS_AND_ANSWERS = '问答题'

/**
 * 问卷状态 - 使用中
 */
export const PROP_SURVEY_PAGER_STATUS_USING = '使用中'

/**
 * 问卷状态 - 停用
 */
export const PROP_SURVEY_PAGER_STATUS_DEACTIVATE = '停用'

/**
 * 问卷状态 - 草稿
 */
export const PROP_SURVEY_PAGER_STATUS_DRAFT = '草稿'

/**
 * 认证方式 - 自动
 */
export const PROP_MEMBER_VERIFICATION_MANNER_AUTOMATIC = '自动'

/**
 * 认证方式 - 审批
 */
export const PROP_MEMBER_VERIFICATION_MANNER_APPROVAL = '审批'

/**
 * 认证状态 - 未认证
 */
export const PROP_MEMBER_VERIFICATION_STATUS_NOT_APPROVED = '未认证'

/**
 * 认证状态 - 待审批
 */
export const PROP_MEMBER_VERIFICATION_STATUS_PENDING = '待审批'

/**
 * 认证状态 - 已认证
 */
export const PROP_MEMBER_VERIFICATION_STATUS_PASSED = '已认证'

/**
 * 认证状态 - 驳回
 */
export const PROP_MEMBER_VERIFICATION_STATUS_TURN_DOWN = '驳回'

/**
 * 卡券类型 - 满减券
 */
export const PROP_COUPON_CUPON_TYPE_FULL_COUPON = '满减券'

/**
 * 卡券类型 - 折扣券
 */
export const PROP_COUPON_CUPON_TYPE_DISCOUNT_COUPON = '折扣券'

/**
 * 卡券类型 - 抵扣券
 */
export const PROP_COUPON_CUPON_TYPE_VOUCHER = '抵扣券'

/**
 * 卡券类型 - 套餐券
 */
export const PROP_COUPON_CUPON_TYPE_PACKAGE_VOUCHER = '套餐券'

/**
 * 卡券定义状态 - 启用
 */
export const PROP_COUPON_DEFINITION_STATUS_ENABLE = '启用'

/**
 * 卡券定义状态 - 停用
 */
export const PROP_COUPON_DEFINITION_STATUS_DEACTIVATE = '停用'

/**
 * 卡券定义状态 - 草稿
 */
export const PROP_COUPON_DEFINITION_STATUS_DRAFT = '草稿'

/**
 * 卡券到期类型 - 固定时间有效
 */
export const PROP_COUPON_EXPIRES_TYPE_EFFECTIVE_AT_FIXED_TIME = '固定时间有效'

/**
 * 卡券到期类型 - 领取后时间长度有效
 */
export const PROP_COUPON_EXPIRES_TYPE_THE_LENGTH_OF_TIME_AFTER_RECEIPT_IS_VALID = '领取后时间长度有效'

/**
 * 卡券到期类型 - 长期有效
 */
export const PROP_COUPON_EXPIRES_TYPE_LONG_TERM_EFFECTIVE = '长期有效'

/**
 * 购买类型 - 赠送
 */
export const PROP_APPLICATION_TYPE_GIVE_AWAY = '赠送'

/**
 * 购买类型 - 购买
 */
export const PROP_APPLICATION_TYPE_BUY = '购买'

/**
 * 核销方式 - 卡券核销
 */
export const PROP_CANCELLATION_AFTER_VERIFICATION_TYPE_CARD_COUPON_VERIFICATION = '卡券核销'

/**
 * 核销方式 - 卡券与现金核销
 */
export const PROP_CANCELLATION_AFTER_VERIFICATION_TYPE_COUPONS_AND_CASH_WRITE_OFFS = '卡券与现金核销'

/**
 * 核销方式 - 单储值卡扣除
 */
export const PROP_CANCELLATION_AFTER_VERIFICATION_TYPE_SINGLE_STORED_VALUE_CARD_DEDUCTION = '单储值卡扣除'

/**
 * 核销方式 - 卡券与储值核销
 */
export const PROP_CANCELLATION_AFTER_VERIFICATION_TYPE_COUPONS_AND_STORED_VALUE_VERIFICATION = '卡券与储值核销'

/**
 * 核销方式 - 卡券、储值与现金核销
 */
export const PROP_CANCELLATION_AFTER_VERIFICATION_TYPE_CARDS_STORED_VALUE_AND_CASH_WRITE_OFF = '卡券、储值与现金核销'

/**
 * 会员来源 - 门店
 */
export const PROP_MEMBER_MEMBER_SOURCE_STORE = '门店'

/**
 * 会员来源 - 公众号
 */
export const PROP_MEMBER_MEMBER_SOURCE_NO_PUBLIC = '公众号'

/**
 * 卡券使用状态 - 未核销
 */
export const PROP_COUPON_USE_STATUS_UNWRITTEN = '未核销'

/**
 * 卡券使用状态 - 已核销
 */
export const PROP_COUPON_USE_STATUS_WRITTEN_OFF = '已核销'

/**
 * 卡券使用状态 - 已过期
 */
export const PROP_COUPON_USE_STATUS_EXPIRED = '已过期'

/**
 * 核销地点 - 店内
 */
export const PROP_VERIFY_SALES_LOCATION_IN_STORE = '店内'

/**
 * 核销地点 - 外出
 */
export const PROP_VERIFY_SALES_LOCATION_GO_OUT = '外出'

/**
 * 审批选项 - 通过
 */
export const PROP_APPROVAL_OPTIONS_PASSED = '通过'

/**
 * 审批选项 - 驳回
 */
export const PROP_APPROVAL_OPTIONS_TURN_DOWN = '驳回'

/**
 * 处理状态 - 已处理
 */
export const PROP_HANDLE_STATUS_ALREADY_PROCESSED = '已处理'

/**
 * 处理状态 - 未处理
 */
export const PROP_HANDLE_STATUS_UNPROCESSED = '未处理'

/**
 * 是否有效 - 有效
 */
export const PROP_IS_EFFECTIVE_EFFECTIVE = '有效'

/**
 * 是否有效 - 无效
 */
export const PROP_IS_EFFECTIVE_INVALID = '无效'

/**
 * 卡券定义审批状态 - 未审批
 */
export const PROP_COUPON_DEFINITION_APPROVE_STATUS_NOT_APPROVED = '未审批'

/**
 * 卡券定义审批状态 - 待审批
 */
export const PROP_COUPON_DEFINITION_APPROVE_STATUS_PENDING = '待审批'

/**
 * 卡券定义审批状态 - 通过
 */
export const PROP_COUPON_DEFINITION_APPROVE_STATUS_BY = '通过'

/**
 * 卡券定义审批状态 - 驳回
 */
export const PROP_COUPON_DEFINITION_APPROVE_STATUS_TURN_DOWN = '驳回'

/**
 * 卡券发放审批状态 - 未审批
 */
export const PROP_COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS_NOT_APPROVED = '未审批'

/**
 * 卡券发放审批状态 - 待审批
 */
export const PROP_COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS_PENDING = '待审批'

/**
 * 卡券发放审批状态 - 已通过
 */
export const PROP_COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS_PASSED = '已通过'

/**
 * 卡券发放审批状态 - 已驳回
 */
export const PROP_COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS_TURN_DOWN = '已驳回'

/**
 * 卡券发放审批状态 - 作废
 */
export const PROP_COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS_BECOME_INVALID = '作废'

/**
 * 金融项目定义状态 - 启用
 */
export const PROP_FINANCIAL_PROJECT_DEFINITION_STATUS_ENABLED = '启用'

/**
 * 金融项目定义状态 - 停用
 */
export const PROP_FINANCIAL_PROJECT_DEFINITION_STATUS_DISABLED = '停用'

/**
 * 金融项目定义状态 - 草稿
 */
export const PROP_FINANCIAL_PROJECT_DEFINITION_STATUS_DRAFT = '草稿'

/**
 * 产品类型 - 储值
 */
export const PROP_MEMBER_PRODUCT_TYPE_RECHARGE = '储值'

/**
 * 产品类型 - 卡券
 */
export const PROP_MEMBER_PRODUCT_TYPE_COUPON = '卡券'

/**
 * 产品类型 - 金融项目
 */
export const PROP_MEMBER_PRODUCT_TYPE_FINANCE_PROJECT = '金融项目'

/**
 * 会员储值记录类型 - 充值
 */
export const PROP_MEMBER_STORED_VALUE_RECORD_TYPE_TOP_UP = '充值'

/**
 * 会员储值记录类型 - 核销
 */
export const PROP_MEMBER_STORED_VALUE_RECORD_TYPE_WRITE_OFF = '核销'

/**
 * 会员储值记录类型 - 商城兑换
 */
export const PROP_MEMBER_STORED_VALUE_RECORD_TYPE_MALL_REDEMPTION = '商城兑换'

/**
 * 婚姻 - 未婚
 */
export const PROP_MARITAL_STATUS_UNMARRIED = '未婚'

/**
 * 婚姻 - 已婚无小孩
 */
export const PROP_MARITAL_STATUS_MARRIED_WITHOUT_CHILDREN = '已婚无小孩'

/**
 * 婚姻 - 已婚有小孩
 */
export const PROP_MARITAL_STATUS_MARRIED_WITH_CHILDREN = '已婚有小孩'

/**
 * 职业 - 公务员
 */
export const PROP_OCCUPATION_CIVIL_SERVANT = '公务员'

/**
 * 职业 - 中高级管理人员
 */
export const PROP_OCCUPATION_SENIOR_MANAGEMENT = '中高级管理人员'

/**
 * 职业 - 中高级技术人员
 */
export const PROP_OCCUPATION_SENIOR_TECHNICAL_STAFF = '中高级技术人员'

/**
 * 职业 - 私营业主
 */
export const PROP_OCCUPATION_PRIVATE_OWNERS = '私营业主'

/**
 * 职业 - 教师
 */
export const PROP_OCCUPATION_TEACHER = '教师'

/**
 * 职业 - 自由职业者
 */
export const PROP_OCCUPATION_FREELANCERS = '自由职业者'

/**
 * 职业 - 销售人员
 */
export const PROP_OCCUPATION_SALESPERSON = '销售人员'

/**
 * 职业 - 医生
 */
export const PROP_OCCUPATION_DOCTORS = '医生'

/**
 * 职业 - 公司职员
 */
export const PROP_OCCUPATION_STAFF = '公司职员'

/**
 * 职业 - 其他
 */
export const PROP_OCCUPATION_OTHER = '其他'

/**
 * 月收入 - 3000
 */
export const PROP_MONTHLY_INCOME_3000 = '3000'

/**
 * 月收入 - 3000-8000
 */
export const PROP_MONTHLY_INCOME_3000_8000 = '3000-8000'

/**
 * 月收入 - 8000-15000
 */
export const PROP_MONTHLY_INCOME_8000_15000 = '8000-15000'

/**
 * 月收入 - 15000以上
 */
export const PROP_MONTHLY_INCOME_15000_OR_MORE = '15000以上'

/**
 * 兴趣爱好 - 电影
 */
export const PROP_HOBBY_THE_FILM = '电影'

/**
 * 兴趣爱好 - 音乐
 */
export const PROP_HOBBY_MUSIC = '音乐'

/**
 * 兴趣爱好 - 运动
 */
export const PROP_HOBBY_MOTION = '运动'

/**
 * 兴趣爱好 - 看书
 */
export const PROP_HOBBY_READING = '看书'

/**
 * 兴趣爱好 - 购物
 */
export const PROP_HOBBY_SHOPPING = '购物'

/**
 * 兴趣爱好 - 旅游
 */
export const PROP_HOBBY_TOURISM = '旅游'

/**
 * 兴趣爱好 - 电子产品
 */
export const PROP_HOBBY_ELECTRONIC_PRODUCT = '电子产品'

/**
 * 兴趣爱好 - 上网
 */
export const PROP_HOBBY_GO_ONLINE = '上网'

/**
 * 兴趣爱好 - 收藏
 */
export const PROP_HOBBY_COLLECT = '收藏'

/**
 * 兴趣爱好 - 棋牌
 */
export const PROP_HOBBY_CHESS = '棋牌'

/**
 * 兴趣爱好 - 聚会
 */
export const PROP_HOBBY_GET_TOGETHER = '聚会'

/**
 * 兴趣爱好 - 游戏
 */
export const PROP_HOBBY_GAME = '游戏'

/**
 * 兴趣爱好 - 摄影
 */
export const PROP_HOBBY_PHOTOGRAPHY = '摄影'

/**
 * 兴趣爱好 - 其他
 */
export const PROP_HOBBY_OTHER = '其他'

/**
 * 车辆用途 - 上下班
 */
export const PROP_VEHICLE_USE_COMMUTE = '上下班'

/**
 * 车辆用途 - 公事
 */
export const PROP_VEHICLE_USE_OFFICIAL_BUSINESS = '公事'

/**
 * 车辆用途 - 休闲
 */
export const PROP_VEHICLE_USE_LEISURE = '休闲'

/**
 * 车辆用途 - 其他
 */
export const PROP_VEHICLE_USE_OTHER = '其他'

/**
 * 年龄 - 20以下
 */
export const PROP_AGE_20_OR_LESS = '20以下'

/**
 * 年龄 - 20-25
 */
export const PROP_AGE_20_25 = '20-25'

/**
 * 年龄 - 25-30
 */
export const PROP_AGE_25_30 = '25-30'

/**
 * 年龄 - 30-35
 */
export const PROP_AGE_30_35 = '30-35'

/**
 * 年龄 - 40-45
 */
export const PROP_AGE_40_45 = '40-45'

/**
 * 年龄 - 45-50
 */
export const PROP_AGE_45_50 = '45-50'

/**
 * 年龄 - 50以上
 */
export const PROP_AGE_ABOVE_50 = '50以上'

/**
 * 回访电话状态 - 接通
 */
export const PROP_CSR_CALL_STATUS_TURN_ON = '接通'

/**
 * 回访电话状态 - 未接通
 */
export const PROP_CSR_CALL_STATUS_NOT_CONNECTED = '未接通'

/**
 * 回访回访状态 - 成功
 */
export const PROP_CSR_ACCESS_STATUS_SUCCESS = '成功'

/**
 * 回访回访状态 - 失败
 */
export const PROP_CSR_ACCESS_STATUS_FAILURE = '失败'

/**
 * 事故统计保险公司 - 平安
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_SAFE = '平安'

/**
 * 事故统计保险公司 - 人保
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_PEOPLE_IS_INSURANCE = '人保'

/**
 * 事故统计保险公司 - 太平洋
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_THE_PACIFIC_OCEAN = '太平洋'

/**
 * 事故统计保险公司 - 大地
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_EARTH = '大地'

/**
 * 事故统计保险公司 - 鑫安
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_XIN_AN = '鑫安'

/**
 * 事故统计保险公司 - 四平人保 
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_SIPING_PEOPLE_IS_INSURANCE = '四平人保 '

/**
 * 事故统计保险公司 - 安华
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_ANWAR = '安华'

/**
 * 事故统计保险公司 - 阳光
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_SUNLIGHT = '阳光'

/**
 * 事故统计保险公司 - 华安
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_HUAAN = '华安'

/**
 * 事故统计保险公司 - 天安
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_TIAN_AN = '天安'

/**
 * 事故统计保险公司 - 华泰
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_HUATAI = '华泰'

/**
 * 事故统计保险公司 - 安邦/大家
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_ANBANG_EVERYONE = '安邦/大家'

/**
 * 事故统计保险公司 - 都邦
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_DUBANG = '都邦'

/**
 * 事故统计保险公司 - 永成
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_YONGCHENG = '永成'

/**
 * 事故统计保险公司 - 安盟
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_UNITA = '安盟'

/**
 * 事故统计保险公司 - 中华联合
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_CHINA_UNITED = '中华联合'

/**
 * 事故统计保险公司 - 太平
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_TAIPING = '太平'

/**
 * 事故统计保险公司 - 亚泰
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_YATAI = '亚泰'

/**
 * 事故统计保险公司 - 英大
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_YINGDA = '英大'

/**
 * 事故统计保险公司 - 美团
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_MEITUAN = '美团'

/**
 * 事故统计保险公司 - 饿了么
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_ARE_YOU_HUNGRY = '饿了么'

/**
 * 事故统计保险公司 - 人寿
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_LIFE = '人寿'

/**
 * 事故统计保险公司 - 店内险
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_IN_STORE_INSURANCE = '店内险'

/**
 * 事故统计保险公司 - 自费
 */
export const PROP_CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_OWN_EXPENSE = '自费'

/**
 * 进店记录转化类别 - 首保
 */
export const PROP_CSM_INCOMING_RECORD_CONVERSION_CATEGORY_CATEGORY_0 = '首保'

/**
 * 进店记录转化类别 - 保养
 */
export const PROP_CSM_INCOMING_RECORD_CONVERSION_CATEGORY_CATEGORY_2 = '保养'

/**
 * 进店记录转化类别 - 维修
 */
export const PROP_CSM_INCOMING_RECORD_CONVERSION_CATEGORY_CATEGORY_3 = '维修'

/**
 * 积分订单状态 - 未领取
 */
export const PROP_PMALL_POINTS_REDEEM_ORDER_STATUS_UNACCALIMED = '未领取'

/**
 * 积分订单状态 - 已领取
 */
export const PROP_PMALL_POINTS_REDEEM_ORDER_STATUS_RECEIVED = '已领取'

/**
 * 积分订单状态 - 已退货
 */
export const PROP_PMALL_POINTS_REDEEM_ORDER_STATUS_RETURNED = '已退货'

/**
 * 进店维修积分获取方式 - 固定分值
 */
export const PROP_PMALL_CAR_MAINTENANCE_POINTS_RULE_COMPUTE_TYPE_FIXED_SCORE = '固定分值'

/**
 * 进店维修积分获取方式 - 比例换算
 */
export const PROP_PMALL_CAR_MAINTENANCE_POINTS_RULE_COMPUTE_TYPE_RATIO_CONVERSION = '比例换算'

/**
 * 积分变更记录类型 - 线下消费
 */
export const PROP_PMALL_MEMBER_POINTS_CHANGE_LOG_TYPE_OFFLINE_CONSUMPTION = '线下消费'

/**
 * 积分变更记录类型 - 兑换商品
 */
export const PROP_PMALL_MEMBER_POINTS_CHANGE_LOG_TYPE_EXCHANGE_GOODS = '兑换商品'

/**
 * 积分变更记录类型 - 积分商品退货
 */
export const PROP_PMALL_MEMBER_POINTS_CHANGE_LOG_TYPE_POINTS_PRODUCT_RETURN = '积分商品退货'

/**
 * 启用状态 - 已启用
 */
export const PROP_PMALL_ENABLED_STATE_ACTIVATED = '已启用'

/**
 * 启用状态 - 未启用
 */
export const PROP_PMALL_ENABLED_STATE_NOT_ACTIVATED = '未启用'

/**
 * 上架状态 - 已上架
 */
export const PROP_PMALL_SHELF_STATUS_IT_HAS_BEEN_ADDED_TO = '已上架'

/**
 * 上架状态 - 未上架
 */
export const PROP_PMALL_SHELF_STATUS_NOT_LISTED = '未上架'

/**
 * 上架状态 - 草稿
 */
export const PROP_PMALL_SHELF_STATUS_DRAFT = '草稿'

/**
 * 奖励类型 - 储值
 */
export const PROP_PMALL_REWARD_TYPE_STORED_VALUE = '储值'

/**
 * 奖励类型 - 卡券
 */
export const PROP_PMALL_REWARD_TYPE_COUPONS = '卡券'

/**
 * 权益发放触发原因 - 等级提升
 */
export const PROP_PMALL_REASONS_FOR_TRIGGERING_BENEFITS_LEVEL_UP = '等级提升'

/**
 * 卡券导入审批状态 - 待审批
 */
export const PROP_COUPON_IMPORT_APPROVE_STATUS_PENDING = '待审批'

/**
 * 卡券导入审批状态 - 已通过
 */
export const PROP_COUPON_IMPORT_APPROVE_STATUS_PASSED = '已通过'

/**
 * 卡券导入审批状态 - 已驳回
 */
export const PROP_COUPON_IMPORT_APPROVE_STATUS_TURN_DOWN = '已驳回'

/**
 * 导入类型 - 卡券
 */
export const PROP_COUPON_IMPORT_TYPE_COUPONS = '卡券'

/**
 * 导入类型 - 方案
 */
export const PROP_COUPON_IMPORT_TYPE_PROGRAM = '方案'

/**
 * 导入类型 - 储值
 */
export const PROP_COUPON_IMPORT_TYPE_STORED_VALUE = '储值'

/**
 * 试驾预约定义状态 - 显示
 */
export const PROP_COUPON_TEST_DRIVE_APPOINTMENT_DEFINITION_STATUS_DISPLAY = '显示'

/**
 * 试驾预约定义状态 - 不显示
 */
export const PROP_COUPON_TEST_DRIVE_APPOINTMENT_DEFINITION_STATUS_DO_NOT_SHOW = '不显示'

/**
 * 试驾预约状态 - 未核实
 */
export const PROP_COUPON_TEST_DRIVE_APPOINTMENT_STATUS_NOT_VERIFIED = '未核实'

/**
 * 试驾预约状态 - 已核实
 */
export const PROP_COUPON_TEST_DRIVE_APPOINTMENT_STATUS_VERIFIED = '已核实'

/**
 * 试驾预约状态 - 已试驾
 */
export const PROP_COUPON_TEST_DRIVE_APPOINTMENT_STATUS_TEST_DRIVEN = '已试驾'

/**
 * 支出或者收入 - 收入
 */
export const PROP_MEMBER_EXPENDITURE_OR_INCOME_INCOME = '收入'

/**
 * 支出或者收入 - 支出
 */
export const PROP_MEMBER_EXPENDITURE_OR_INCOME_EXPENDITURE = '支出'

/**
 * 积分兑换兑换方式 - 积分兑换
 */
export const PROP_MEMBER_HOW_TO_REDEEM_POINTS_REDEEM = '积分兑换'

/**
 * 积分兑换兑换方式 - 储值卡扣除
 */
export const PROP_MEMBER_HOW_TO_REDEEM_POINTS_STORED_VALUE_CARD_DEDUCTION = '储值卡扣除'

/**
 * 积分兑换兑换方式 - 微信支付
 */
export const PROP_MEMBER_HOW_TO_REDEEM_POINTS_WECHAT_PAY = '微信支付'

/**
 * 积分兑换兑换方式 - 微信积分混合支付
 */
export const PROP_MEMBER_HOW_TO_REDEEM_POINTS_WECHAT_POINTS_HYBRID_PAYMENT = '微信积分混合支付'

/**
 * 预约信息状态 - 待处理
 */
export const PROP_MEMBER_MEMBER_RESERVATION_INFO_STATUS_PENDING = '待处理'

/**
 * 预约信息状态 - 无效
 */
export const PROP_MEMBER_MEMBER_RESERVATION_INFO_STATUS_INVALID = '无效'

/**
 * 预约信息状态 - 已预约
 */
export const PROP_MEMBER_MEMBER_RESERVATION_INFO_STATUS_BOOKED = '已预约'

/**
 * 预约信息类别 - 保养
 */
export const PROP_MEMBER_MEMBER_RESERVATION_INFO_TYPE_MAINTENANCE = '保养'

/**
 * 预约信息类别 - 维修
 */
export const PROP_MEMBER_MEMBER_RESERVATION_INFO_TYPE_SERVICE = '维修'

/**
 * 预约信息类别 - 检测
 */
export const PROP_MEMBER_MEMBER_RESERVATION_INFO_TYPE_DETECT = '检测'

/**
 * 数据类型 - 新车客户
 */
export const CSM_DATA_TYPE_NEW_CAR = 1000

/**
 * 数据类型 - 首保客户
 */
export const CSM_DATA_TYPE_FIRST_MAINTENANCE = 1001

/**
 * 数据类型 - 二保客户
 */
export const CSM_DATA_TYPE_SECOND_MAINTENANCE = 1002

/**
 * 数据类型 - 维修客户
 */
export const CSM_DATA_TYPE_MAINTENANCE = 1003

/**
 * 数据类型 - 仅事故客户
 */
export const CSM_DATA_TYPE_ONLY_ACCIDENT = 1004

/**
 * 数据类型 - 在保流失
 */
export const CSM_DATA_TYPE_IN_WARRANTY = 1005

/**
 * 数据类型 - 出保流失
 */
export const CSM_DATA_TYPE_OUT_WARRANTY = 1006

/**
 * 数据类型 - 常规客户
 */
export const CSM_DATA_TYPE_ORDINARY = 1008

/**
 * 数据类型 - 流失预警
 */
export const CSM_DATA_TYPE_LOSS_ALARM = 1009

/**
 * 数据类型 - 质保到期
 */
export const CSM_DATA_TYPE_EXPIRED = 1007

/**
 * 维修类别 - 首保
 */
export const CSM_MAINTAIN_CATEGORY_0_ = 1000

/**
 * 维修类别 - 索赔
 */
export const CSM_MAINTAIN_CATEGORY_1_ = 1001

/**
 * 维修类别 - 保养
 */
export const CSM_MAINTAIN_CATEGORY_2_ = 1002

/**
 * 维修类别 - 小修
 */
export const CSM_MAINTAIN_CATEGORY_3_ = 1003

/**
 * 维修类别 - 大修
 */
export const CSM_MAINTAIN_CATEGORY_4_ = 1114

/**
 * 维修类别 - 自费事故
 */
export const CSM_MAINTAIN_CATEGORY_5_ = 1004

/**
 * 维修类别 - 年审
 */
export const CSM_MAINTAIN_CATEGORY_7_ = 1115

/**
 * 维修类别 - PDI
 */
export const CSM_MAINTAIN_CATEGORY_8_ = 1005

/**
 * 维修类别 - 内修
 */
export const CSM_MAINTAIN_CATEGORY_9_ = 1116

/**
 * 维修类别 - 优惠索赔
 */
export const CSM_MAINTAIN_CATEGORY_G_ = 1006

/**
 * 维修类别 - 预PDI
 */
export const CSM_MAINTAIN_CATEGORY_P_ = 1007

/**
 * 维修类别 - 升级
 */
export const CSM_MAINTAIN_CATEGORY_S_ = 1010

/**
 * 维修类别 - 外出救援
 */
export const CSM_MAINTAIN_CATEGORY_U_ = 1117

/**
 * 维修类别 - 行动
 */
export const CSM_MAINTAIN_CATEGORY_V_ = 1008

/**
 * 维修类别 - 召回
 */
export const CSM_MAINTAIN_CATEGORY_Z_ = 1009

/**
 * 维修类别 - 忠诚度
 */
export const CSM_MAINTAIN_CATEGORY_XD_ = 1111

/**
 * 维修类别 - 免费检查
 */
export const CSM_MAINTAIN_CATEGORY_M_ = 1112

/**
 * 维修类别 - 保险事故
 */
export const CSM_MAINTAIN_CATEGORY_A_ = 1113

/**
 * 购车门店 - 本店
 */
export const CSM_BOUGHT_STORE_THIS_STORE = 1000

/**
 * 购车门店 - 其他店
 */
export const CSM_BOUGHT_STORE_OTHER_STORE = 1100

/**
 * 车辆状态 - 预约进店保养
 */
export const CSM_VEHICLE_STATUS_RESERVATION_MAINTENANCE = 1000

/**
 * 车辆状态 - 邀约进店保养
 */
export const CSM_VEHICLE_STATUS_INVITATION_MAINTENANCE = 1001

/**
 * 车辆状态 - 预约上门排期
 */
export const CSM_VEHICLE_STATUS_APPOINTMENT_SCHEDULE = 1002

/**
 * 车辆状态 - 邀约上门排期
 */
export const CSM_VEHICLE_STATUS_INVITATION_SCHEDULE = 1003

/**
 * 车辆状态 - 未记里程
 */
export const CSM_VEHICLE_STATUS_LESS_THAN_FIVE_HUNDRED = 1005

/**
 * 车辆状态 - 未到里程
 */
export const CSM_VEHICLE_STATUS_LESS_THAN_MILEAGE = 1007

/**
 * 车辆状态 - 车已流失，放弃
 */
export const CSM_VEHICLE_STATUS_CAR_LOSS_ABORT = 1009

/**
 * 车辆状态 - 活动进店
 */
export const CSM_VEHICLE_STATUS_ACTIVITY_ENTERS_STORE = 1011

/**
 * 车辆状态 - 活动不进店
 */
export const CSM_VEHICLE_STATUS_ACTIVITY_ENTERS_NOT_STORE = 1012

/**
 * 车辆状态 - 进店时间不确定
 */
export const CSM_VEHICLE_STATUS_ACTIVITY_ENTERS_UNCERTAIN_STORE = 1013

/**
 * 车辆状态 - 流失预警
 */
export const CSM_VEHICLE_STATUS_CAR_LOSS_ALARM = 1014

/**
 * 车辆状态 - 已保养
 */
export const CSM_VEHICLE_STATUS_MAINTAINED = 1015

/**
 * 活动车辆状态 - 活动进店
 */
export const CSM_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_STORE = 1011

/**
 * 活动车辆状态 - 活动不进店
 */
export const CSM_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_NOT_STORE = 1012

/**
 * 活动车辆状态 - 进店时间不确定
 */
export const CSM_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_UNCERTAIN_STORE = 1013

/**
 * 活动车辆状态 - 未到里程
 */
export const CSM_ACTIVITY_VEHICLE_STATUS_UNREACHED_MILEAGE = 1007

/**
 * 精品活动车辆状态 - 跟踪
 */
export const CSM_BOUTIQUE_ACTIVITY_VEHICLE_STATUS_BOUTIQUE_ACTIVITY_TRACK = 1016

/**
 * 精品活动车辆状态 - 预定
 */
export const CSM_BOUTIQUE_ACTIVITY_VEHICLE_STATUS_BOUTIQUE_ACTIVITY_PREORDAIN = 1017

/**
 * 精品活动车辆状态 - 战败
 */
export const CSM_BOUTIQUE_ACTIVITY_VEHICLE_STATUS_BOUTIQUE_ACTIVITY_DEFEATED = 1018

/**
 * 通话状态 - 有效沟通
 */
export const CSM_CALL_STATUS_VALID_INTERVIEW = 1000

/**
 * 通话状态 - 未接通
 */
export const CSM_CALL_STATUS_NOT_INTERVIEWED = 1001

/**
 * 通话状态 - 无效电话
 */
export const CSM_CALL_STATUS_INVALID_CALL = 1002

/**
 * 通话状态 - 无效沟通
 */
export const CSM_CALL_STATUS_INVALID_INTERVIEW = 1003

/**
 * 通话状态 - 未拨打
 */
export const CSM_CALL_STATUS_NOT_DIALED = 1004

/**
 * 通话状态 - 没联系上
 */
export const CSM_CALL_STATUS_NOT_CONTACTED = 1005

/**
 * 通话状态 - 没联系上-近期就来
 */
export const CSM_CALL_STATUS_NOT_CONTACTED_NOT_COMING_SOON = 1006

/**
 * 客户状态 - 首保未进厂
 */
export const CSM_CUSTOMER_STATUS_FIRST_MAINTENANCE_NO_ENTERED_STORE = 1000

/**
 * 客户状态 - 首保回厂
 */
export const CSM_CUSTOMER_STATUS_FIRST_MAINTENANCE_ENTERED_STORE = 1001

/**
 * 客户状态 - 二保回厂
 */
export const CSM_CUSTOMER_STATUS_SECOND_MAINTENANCE_ENTERED_STORE = 1002

/**
 * 客户状态 - 保养忠实
 */
export const CSM_CUSTOMER_STATUS_MAINTENANCE_LOYAL = 1003

/**
 * 客户状态 - 保养流失
 */
export const CSM_CUSTOMER_STATUS_MAINTENANCE_LOST = 1004

/**
 * 客户状态 - 保养回厂
 */
export const CSM_CUSTOMER_STATUS_MAINTENANCE_ENTERED_FACTORY = 1005

/**
 * 客户状态 - 保养三次
 */
export const CSM_CUSTOMER_STATUS_MAINTENANCE_QTY_3 = 1006

/**
 * 客户状态 - 进厂三次
 */
export const CSM_CUSTOMER_STATUS_ENTERED_FACTORY_QTY_3 = 1007

/**
 * 客户状态 - 流失预警
 */
export const CSM_CUSTOMER_STATUS_LOSS_ALARM = 1008

/**
 * 客户状态 - 维修进厂
 */
export const CSM_CUSTOMER_STATUS_MAINTENANCE_TO_FACTORY = 1009

/**
 * 客户状态 - 事故进厂
 */
export const CSM_CUSTOMER_STATUS_ACCIDENT_TO_FACTORY = 1010

/**
 * 客户状态 - 流失
 */
export const CSM_CUSTOMER_STATUS_LOSS = 1011

/**
 * 客户状态 - 无效休眠
 */
export const CSM_CUSTOMER_STATUS_INVALID_HIBERNATE = 1012

/**
 * 客户状态 - 放弃
 */
export const CSM_CUSTOMER_STATUS_ABORT = 1013

/**
 * 邀约状态 - 已邀约
 */
export const CSM_INVITATION_STATUS_INVITATION_STATUS_SUCESS = 1000

/**
 * 邀约状态 - 未邀约
 */
export const CSM_INVITATION_STATUS_INVITATION_STATUS_NOT_STARTED = 1100

/**
 * 进店状态 - 已进店
 */
export const CSM_ENTER_STORE_TO_SHOP = 1000

/**
 * 进店状态 - 未进店
 */
export const CSM_ENTER_STORE_NOT_TO_SHOP = 1100

/**
 * 精品活动进店状态 - 待确认
 */
export const CSM_BOUTIQUE_ENTER_STORE_TO_BE_CONFIRMED = 1100

/**
 * 精品活动进店状态 - 成功
 */
export const CSM_BOUTIQUE_ENTER_STORE_SUCCESS = 1000

/**
 * 精品活动进店状态 - 失败
 */
export const CSM_BOUTIQUE_ENTER_STORE_FAILURE = 1200

/**
 * 状态 - 进行中
 */
export const CSM_INVITATION_REQ_EXT_STATUS_INVITATION_PROCESSING = 1000

/**
 * 状态 - 已结束
 */
export const CSM_INVITATION_REQ_EXT_STATUS_INVITATION_FINISHED = 1100

/**
 * 状态 - 驳回
 */
export const CSM_INVITATION_REQ_EXT_STATUS_INVITATION_REJECT = 1200

/**
 * 状态 - 终止
 */
export const CSM_INVITATION_REQ_EXT_STATUS_INVITATION_TERMINATED = 1300

/**
 * 状态 - 待审批
 */
export const CSM_INVITATION_REQ_EXT_STATUS_INVITATION_PENDING = 1400

/**
 * 活动类别 - 售后活动
 */
export const CSM_ACTIVITY_CATEGORY_ACTIVITY_CATEGORY_AFTER_SALE = 1004

/**
 * 活动类别 - 精品活动
 */
export const CSM_ACTIVITY_CATEGORY_ACTIVITY_CATEGORY_BOUTIQUE = 1005

/**
 * 邀约类别 - 日常邀约
 */
export const CSM_INVITATION_CATEGORY_ORDINARY = 1000

/**
 * 邀约类别 - 售后活动邀约
 */
export const CSM_INVITATION_CATEGORY_ACTIVITY = 1100

/**
 * 邀约类别 - 延保邀约
 */
export const CSM_INVITATION_CATEGORY_EXTENSION = 1200

/**
 * 邀约类别 - 精品活动邀约
 */
export const CSM_INVITATION_CATEGORY_BOUTIQUE_ACTIVITY = 1300

/**
 * 邀约类别 - 质量担保期邀约
 */
export const CSM_INVITATION_CATEGORY_WARRANTY_PERIOD = 1400

/**
 * 邀约类别 - 客户关怀邀约
 */
export const CSM_INVITATION_CATEGORY_CARE_CUSTOMER = 1500

/**
 * 预约状态 - 预约中
 */
export const CSM_RESERVATION_STATUS_PROCESSING = 1000

/**
 * 预约状态 - 取消
 */
export const CSM_RESERVATION_STATUS_CANCELED = 1100

/**
 * 回访类型 - 0-
 */
export const CSM_VISIT_CATEGORY_0_ = 1000

/**
 * 回访类型 - 1-
 */
export const CSM_VISIT_CATEGORY_1_ = 1001

/**
 * 回访类型 - 2-
 */
export const CSM_VISIT_CATEGORY_2_ = 1002

/**
 * 回访类型 - 3-
 */
export const CSM_VISIT_CATEGORY_3_ = 1003

/**
 * 回访类型 - 5-
 */
export const CSM_VISIT_CATEGORY_5_ = 1004

/**
 * 回访类型 - 8-
 */
export const CSM_VISIT_CATEGORY_8_ = 1005

/**
 * 回访类型 - G-
 */
export const CSM_VISIT_CATEGORY_G_ = 1006

/**
 * 回访类型 - P-
 */
export const CSM_VISIT_CATEGORY_P_ = 1007

/**
 * 回访类型 - S-
 */
export const CSM_VISIT_CATEGORY_S_ = 1008

/**
 * 回访类型 - V-
 */
export const CSM_VISIT_CATEGORY_V_ = 1009

/**
 * 回访类型 - Z-
 */
export const CSM_VISIT_CATEGORY_Z_ = 1010

/**
 * 回访类型 - XD_
 */
export const CSM_VISIT_CATEGORY_XD_ = 1111

/**
 * 电话状态 - 呼出
 */
export const CSM_PHONE_STATUS_CALL_OUT = 1000

/**
 * 电话状态 - 来电
 */
export const CSM_PHONE_STATUS_CALL_IN = 1100

/**
 * 车辆产地 - 国产
 */
export const CSM_VEHICLE_ORIGIN_DOMESTIC = 1000

/**
 * 车辆产地 - 进口
 */
export const CSM_VEHICLE_ORIGIN_IMPORTED = 1100

/**
 * Portal维修类别 - 首保
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_0 = '0'

/**
 * Portal维修类别 - 索赔
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_1 = '1'

/**
 * Portal维修类别 - 保养
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_2 = '2'

/**
 * Portal维修类别 - 小修
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_3 = '3'

/**
 * Portal维修类别 - 大修
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_4 = '4'

/**
 * Portal维修类别 - 自费事故
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_5 = '5'

/**
 * Portal维修类别 - 年审
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_7 = '7'

/**
 * Portal维修类别 - PDI
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_8 = '8'

/**
 * Portal维修类别 - 内修
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_9 = '9'

/**
 * Portal维修类别 - 优惠索赔
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_G = 'G'

/**
 * Portal维修类别 - 预PDI
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_P = 'P'

/**
 * Portal维修类别 - 升级
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_S = 'S'

/**
 * Portal维修类别 - 外出救援
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_U = 'U'

/**
 * Portal维修类别 - 行动
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_V = 'V'

/**
 * Portal维修类别 - 召回
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_Z = 'Z'

/**
 * Portal维修类别 - 免费检查
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_M = 'M'

/**
 * Portal维修类别 - 保险事故
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY_A = 'A'

/**
 * 邀约记录数据来源 - 迈道
 */
export const CSM_INVITATION_DATA_SOURCE_MDC = 1000

/**
 * 邀约记录数据来源 - 洞察分析平台
 */
export const CSM_INVITATION_DATA_SOURCE_SIP = 1001

/**
 * 车辆维修记录来源类别 - DMS
 */
export const CSM_MAINTENANCE_SOURCE_TYPE_DMS = 1

/**
 * 车辆维修记录来源类别 - Portal
 */
export const CSM_MAINTENANCE_SOURCE_TYPE_PORTAL = 2

/**
 * 车型名称 - A1
 */
export const CSM_VEHICLE_NAME_A1 = 'A1'

/**
 * 车型名称 - S3
 */
export const CSM_VEHICLE_NAME_S3 = 'S3'

/**
 * 车型名称 - A3
 */
export const CSM_VEHICLE_NAME_A3 = 'A3'

/**
 * 车型名称 - A4
 */
export const CSM_VEHICLE_NAME_A4 = 'A4'

/**
 * 车型名称 - A5
 */
export const CSM_VEHICLE_NAME_A5 = 'A5'

/**
 * 车型名称 - A6
 */
export const CSM_VEHICLE_NAME_A6 = 'A6'

/**
 * 车型名称 - A7
 */
export const CSM_VEHICLE_NAME_A7 = 'A7'

/**
 * 车型名称 - A8
 */
export const CSM_VEHICLE_NAME_A8 = 'A8'

/**
 * 车型名称 - Q2
 */
export const CSM_VEHICLE_NAME_Q2 = 'Q2'

/**
 * 车型名称 - Q3
 */
export const CSM_VEHICLE_NAME_Q3 = 'Q3'

/**
 * 车型名称 - Q5
 */
export const CSM_VEHICLE_NAME_Q5 = 'Q5'

/**
 * 车型名称 - Q5L
 */
export const CSM_VEHICLE_NAME_Q5L = 'Q5L'

/**
 * 车型名称 - Q7
 */
export const CSM_VEHICLE_NAME_Q7 = 'Q7'

/**
 * 车型名称 - TT
 */
export const CSM_VEHICLE_NAME_TT = 'TT'

/**
 * 车型名称 - R8
 */
export const CSM_VEHICLE_NAME_R8 = 'R8'

/**
 * 车型名称 - Q8
 */
export const CSM_VEHICLE_NAME_Q8 = 'Q8'

/**
 * 车型名称 - etron
 */
export const CSM_VEHICLE_NAME_ETRON = 'etron'

/**
 * 车型名称 - XD
 */
export const CSM_VEHICLE_NAME_XD = 'XD'

/**
 * 客户关系状态 - 正常
 */
export const IIM_CUSTOMER_RELATION_COSTOMER_RELATION_NORMAL = 1000

/**
 * 客户关系状态 - 放弃
 */
export const IIM_CUSTOMER_RELATION_COSTOMER_RELATION_GIVE_UP = 1010

/**
 * 客户关系状态 - 废弃
 */
export const IIM_CUSTOMER_RELATION_COSTOMER_RELATION_DISCARD = 1020

/**
 * 接触轮次 - 首次接触
 */
export const IIM_INVITATION_ROUNDS_INVITATION_ROUNDS_FIRST = 1000

/**
 * 接触轮次 - 二次接触
 */
export const IIM_INVITATION_ROUNDS_INVITATION_ROUNDS_TWICE = 1001

/**
 * 接触轮次 - 三次接触
 */
export const IIM_INVITATION_ROUNDS_INVITATION_ROUNDS_THREE = 1002

/**
 * 接触轮次 - 多次接触
 */
export const IIM_INVITATION_ROUNDS_INVITATION_ROUNDS_REPEATEDLY = 1003

/**
 * 保险险种 - 交强险
 */
export const IIM_INSURANCE_INSURANCE_TYPE_FORCE_CODE = 1000

/**
 * 保险险种 - 机动车商业保险单
 */
export const IIM_INSURANCE_INSURANCE_TYPE_BUSINESS_CODE = 1010

/**
 * 通话状态 - 有效沟通
 */
export const IIM_CALL_STATUS_VALID_INTERVIEW = 1000

/**
 * 通话状态 - 未接通
 */
export const IIM_CALL_STATUS_NOT_INTERVIEWED = 1001

/**
 * 通话状态 - 无效电话
 */
export const IIM_CALL_STATUS_INVALID_CALL = 1002

/**
 * 通话状态 - 无效沟通
 */
export const IIM_CALL_STATUS_INVALID_INTERVIEW = 1003

/**
 * 通话状态 - 未拨打
 */
export const IIM_CALL_STATUS_NOT_DIALED = 1004

/**
 * 通话状态 - 延时邀约
 */
export const IIM_CALL_STATUS_DELAY_INSURANCE = 1005

/**
 * 续保状态 - 跟踪
 */
export const IIM_RENEWAL_OF_INSURANCE_STATUS_CUSTOMER_RELATION_TRACK = 1000

/**
 * 续保状态 - 交商共保
 */
export const IIM_RENEWAL_OF_INSURANCE_STATUS_CUSTOMER_RELATION_SUCCESS = 1100

/**
 * 续保状态 - 战败
 */
export const IIM_RENEWAL_OF_INSURANCE_STATUS_CUSTOMER_RELATION_DEFEATED = 1200

/**
 * 续保状态 - 单交强
 */
export const IIM_RENEWAL_OF_INSURANCE_STATUS_SINGLE_CROSS_STRONG = 1300

/**
 * 续保状态 - 单商业
 */
export const IIM_RENEWAL_OF_INSURANCE_STATUS_SINGLE_BUSINESS = 1400

/**
 * 邀约状态 - 已邀约
 */
export const IIM_INVITATION_STATUS_INVITATION_STATUS_SUCCESS = 1000

/**
 * 邀约状态 - 未邀约
 */
export const IIM_INVITATION_STATUS_INVITATION_STATUS_NOT_STARTED = 1100

/**
 * 客户类别 - 新保
 */
export const IIM_CUSTOMER_TYPE_XINBAO = 1000

/**
 * 客户类别 - 在修不在保
 */
export const IIM_CUSTOMER_TYPE_UNDER_REPAIR = 1001

/**
 * 客户类别 - 不在修不在保
 */
export const IIM_CUSTOMER_TYPE_NOT_REPAIR = 1002

/**
 * 客户类别 - 新转续
 */
export const IIM_CUSTOMER_TYPE_NEW_RENEWAL = 1003

/**
 * 客户类别 - 续转续
 */
export const IIM_CUSTOMER_TYPE_CONTINUE = 1004

/**
 * 客户类别 - 单交强
 */
export const IIM_CUSTOMER_TYPE_SINGLE_CROSS_STRONG = 1005

/**
 * 客户类别 - 单三者
 */
export const IIM_CUSTOMER_TYPE_SINGLE_THREE = 1006

/**
 * 客户类别 - 其他
 */
export const IIM_CUSTOMER_TYPE_OTHER = 1007

/**
 * 车型名称 - A1
 */
export const IIM_VEHICLE_NAME_A1 = 'A1'

/**
 * 车型名称 - S3
 */
export const IIM_VEHICLE_NAME_S3 = 'S3'

/**
 * 车型名称 - A3
 */
export const IIM_VEHICLE_NAME_A3 = 'A3'

/**
 * 车型名称 - A4
 */
export const IIM_VEHICLE_NAME_A4 = 'A4'

/**
 * 车型名称 - A5
 */
export const IIM_VEHICLE_NAME_A5 = 'A5'

/**
 * 车型名称 - A6
 */
export const IIM_VEHICLE_NAME_A6 = 'A6'

/**
 * 车型名称 - A7
 */
export const IIM_VEHICLE_NAME_A7 = 'A7'

/**
 * 车型名称 - A8
 */
export const IIM_VEHICLE_NAME_A8 = 'A8'

/**
 * 车型名称 - Q2
 */
export const IIM_VEHICLE_NAME_Q2 = 'Q2'

/**
 * 车型名称 - Q3
 */
export const IIM_VEHICLE_NAME_Q3 = 'Q3'

/**
 * 车型名称 - Q5
 */
export const IIM_VEHICLE_NAME_Q5 = 'Q5'

/**
 * 车型名称 - Q5L
 */
export const IIM_VEHICLE_NAME_Q5L = 'Q5L'

/**
 * 车型名称 - Q7
 */
export const IIM_VEHICLE_NAME_Q7 = 'Q7'

/**
 * 车型名称 - TT
 */
export const IIM_VEHICLE_NAME_TT = 'TT'

/**
 * 车型名称 - R8
 */
export const IIM_VEHICLE_NAME_R8 = 'R8'

/**
 * 车型名称 - XD
 */
export const IIM_VEHICLE_NAME_XD = 'XD'

/**
 * 客户续保状态 - 已续保
 */
export const IIM_CALL_STATUS_INSURANCE_STATUS_INSURANCE_NORMAL = 1000

/**
 * 客户续保状态 - 未续保
 */
export const IIM_CALL_STATUS_INSURANCE_STATUS_NOT_INSURANCE_NORMAL = 1100

/**
 * 营销活动实例状态 - 已创建
 */
export const DEMO_MARKETING_ACTIVITY_STATUS_MARKETING_ACTIVITY_STATUS_NORMAL = 1001

/**
 * 营销活动实例状态 - 进行中
 */
export const DEMO_MARKETING_ACTIVITY_STATUS_MARKETING_ACTIVITY_STATUS_PROCESSING = 1002

/**
 * 营销活动实例状态 - 已终止
 */
export const DEMO_MARKETING_ACTIVITY_STATUS_MARKETING_ACTIVITY_STATUS_TERMINATION = 1003

/**
 * 营销活动实例状态 - 已完成
 */
export const DEMO_MARKETING_ACTIVITY_STATUS_MARKETING_ACTIVITY_STATUS_CARRY_OUT = 1004

/**
 * 营销活动推荐状态 - 进行中
 */
export const DEMO_SUGGEST_MARKETING_ACTIVITY_STATUS_SUGGEST_MARKETING_ACTIVITY_STATUS_PROCESSING = 1002

/**
 * 营销活动推荐状态 - 已终止
 */
export const DEMO_SUGGEST_MARKETING_ACTIVITY_STATUS_SUGGEST_MARKETING_ACTIVITY_STATUS_TERMINATION = 1003

/**
 * 营销活动推荐计算周期 - 每年
 */
export const DEMO_SUGGEST_MARKETING_ACTIVITY_CALCULATION_CYCLE_CALCULATION_CYCLE_YEARLY = 1000

/**
 * 营销活动推荐计算周期 - 每季度
 */
export const DEMO_SUGGEST_MARKETING_ACTIVITY_CALCULATION_CYCLE_CALCULATION_CYCLE_QUARTERLY = 1200

/**
 * 营销活动推荐计算周期 - 每月
 */
export const DEMO_SUGGEST_MARKETING_ACTIVITY_CALCULATION_CYCLE_CALCULATION_CYCLE_MONTHLY = 1300

/**
 * 模型活动车辆状态 - 活动进店
 */
export const DEMO_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_STORE = 1011

/**
 * 模型活动车辆状态 - 活动不进店
 */
export const DEMO_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_NOT_STORE = 1012

/**
 * 模型活动车辆状态 - 活动不确定进店
 */
export const DEMO_ACTIVITY_VEHICLE_STATUS_ACTIVITY_ENTERS_UNCERTAIN_STORE = 1013

/**
 * 模型日常车辆状态 - 预约进店保养
 */
export const DEMO_DAILY_VEHICLE_STATUS_RESERVATION_MAINTENANCE = 1000

/**
 * 模型日常车辆状态 - 邀约进店保养
 */
export const DEMO_DAILY_VEHICLE_STATUS_INVITATION_MAINTENANCE = 1001

/**
 * 模型日常车辆状态 - 未到里程500
 */
export const DEMO_DAILY_VEHICLE_STATUS_LESS_THAN_FIVE_HUNDRED = 1005

/**
 * 模型日常车辆状态 - 未到里程1000
 */
export const DEMO_DAILY_VEHICLE_STATUS_LESS_THAN_THOUSAND = 1006

/**
 * 模型日常车辆状态 - 未到里程
 */
export const DEMO_DAILY_VEHICLE_STATUS_LESS_THAN_MILEAGE = 1007

/**
 * 模型日常车辆状态 - 车已流失，放弃
 */
export const DEMO_DAILY_VEHICLE_STATUS_CAR_LOSS_ABORT = 1009

/**
 * 模型日常维修类别 - 首保
 */
export const DEMO_DAILY_MAINTAIN_CATEGORY_0_ = 1000

/**
 * 模型日常维修类别 - 保养
 */
export const DEMO_DAILY_MAINTAIN_CATEGORY_2_ = 1002

/**
 * 保险公司 - 人保
 */
export const IIM_INSURANCE_COMPANY_INSURER_TYPE_BUSINESS_CODE = 2001

/**
 * 保险公司 - 平安
 */
export const IIM_INSURANCE_COMPANY_PINGANINSURANCE_TYPE_BUSINESS_CODE = 2002

/**
 * 保险公司 - 太平洋
 */
export const IIM_INSURANCE_COMPANY_CHINAPACIFICINSURANCE_TYPE_BUSINESS_CODE = 2003

/**
 * 保险公司 - 中华联合
 */
export const IIM_INSURANCE_COMPANY_THECHINESEINSURANCE_TYPE_BUSINESS_CODE = 2004

/**
 * 保险公司 - 人寿
 */
export const IIM_INSURANCE_COMPANY_THELIFEINSURANCE_TYPE_BUSINESS_CODE = 2005

/**
 * 保险公司 - 都邦
 */
export const IIM_INSURANCE_COMPANY_FORINSURANCE_TYPE_BUSINESS_CODE = 2006

/**
 * 保险公司 - 大地
 */
export const IIM_INSURANCE_COMPANY_GROUNDINSURER_TYPE_BUSINESS_CODE = 2007

/**
 * 保险公司 - 阳光
 */
export const IIM_INSURANCE_COMPANY_SUNSHINEINSURANCE_TYPE_BUSINESS_CODE = 2008

/**
 * 保险公司 - 天安
 */
export const IIM_INSURANCE_COMPANY_TIANANINSURANCE_TYPE_BUSINESS_CODE = 2009

/**
 * 保险公司 - 永安
 */
export const IIM_INSURANCE_COMPANY_YONGANINSURANCE_TYPE_BUSINESS_CODE = 2010

/**
 * 保险公司 - 华安
 */
export const IIM_INSURANCE_COMPANY_HUAANINSURER_TYPE_BUSINESS_CODE = 2011

/**
 * 保险公司 - 安邦
 */
export const IIM_INSURANCE_COMPANY_BUSINESSINSURANCE_TYPE_BUSINESS_CODE = 2012

/**
 * 保险公司 - 永诚
 */
export const IIM_INSURANCE_COMPANY_YONGCHENGINSURANCE_TYPE_BUSINESS_CODE = 2013

/**
 * 保险公司 - 太平
 */
export const IIM_INSURANCE_COMPANY_TAIPINGGENERALINSURANCE_TYPE_BUSINESS_CODE = 2014

/**
 * 保险公司 - 中银
 */
export const IIM_INSURANCE_COMPANY_BOCINSURANCE_TYPE_BUSINESS_CODE = 2015

/**
 * 保险公司 - 渤海
 */
export const IIM_INSURANCE_COMPANY_THEBOHAISEAGENERALINSURANCE_TYPE_BUSINESS_CODE = 2016

/**
 * 保险公司 - 亚太
 */
export const IIM_INSURANCE_COMPANY_ASIAPACIFICINSURANCE_TYPE_BUSINESS_CODE = 2017

/**
 * 保险公司 - 安华
 */
export const IIM_INSURANCE_COMPANY_ANHUAAGRICULTURALINSURANCE_TYPE_BUSINESS_CODE = 2018

/**
 * 保险公司 - 英大
 */
export const IIM_INSURANCE_COMPANY_THEBIGTAIHE_TYPE_BUSINESS_CODE = 2019

/**
 * 保险公司 - 信达
 */
export const IIM_INSURANCE_COMPANY_CINDAPC_TYPE_BUSINESS_CODE = 2020

/**
 * 保险公司 - 其他
 */
export const IIM_INSURANCE_COMPANY_RESTS_TYPE_BUSINESS_CODE = 2021

/**
 * 保险公司 - 鑫安
 */
export const IIM_INSURANCE_COMPANY_XINAN_BUSINESS_CODE = 2022

/**
 * 子险种类别主险 - 车损险
 */
export const IIM_SON_INSURANCE_MAIN_CARDAMAGEINSURANCE_TYPE_BUSINESS_CODE = 2101

/**
 * 子险种类别主险 - 第三者责任险
 */
export const IIM_SON_INSURANCE_MAIN_THIRDPARTY_TYPE_BUSINESS_CODE = 2102

/**
 * 子险种类别主险 - 车上司机险
 */
export const IIM_SON_INSURANCE_MAIN_DRIVER_TYPE_BUSINESS_CODE = 2103

/**
 * 子险种类别主险 - 车上乘客险
 */
export const IIM_SON_INSURANCE_MAIN_PASSENGER_TYPE_BUSINESS_CODE = 2104

/**
 * 子险种类别主险 - 全车盗抢险
 */
export const IIM_SON_INSURANCE_MAIN_ALLCARTHEFT_TYPE_BUSINESS_CODE = 2105

/**
 * 子险种类别附加险 - 车身划痕险
 */
export const IIM_SON_INSURANCE_ATTACH_BODYSCRATCHES_TYPE_BUSINESS_CODE = 2106

/**
 * 子险种类别附加险 - 玻璃破碎险
 */
export const IIM_SON_INSURANCE_ATTACH_GLASS_TYPE_BUSINESS_CODE = 2107

/**
 * 子险种类别附加险 - 自燃损失险
 */
export const IIM_SON_INSURANCE_ATTACH_NATURE_TYPE_BUSINESS_CODE = 2108

/**
 * 子险种类别附加险 - 涉水险
 */
export const IIM_SON_INSURANCE_ATTACH_WADING_TYPE_BUSINESS_CODE = 2109

/**
 * 子险种类别附加险 - 车损无第三方
 */
export const IIM_SON_INSURANCE_ATTACH_NOTHIRDPARTYINDAMAGE_TYPE_BUSINESS_CODE = 2110

/**
 * 商业子险种类别 - 主险
 */
export const _IIM_BRANCH_OF_INSURANCE_MAIN_INSURANCE_TYPE_BUSINESS_CODE = 2200

/**
 * 商业子险种类别 - 附加险
 */
export const _IIM_BRANCH_OF_INSURANCE_ATTACH_INSURANCE_TYPE_BUSINESS_CODE = 2201

/**
 * 年度任务名称 - 延保销量
 */
export const CSM_TASK_NAME_EXTENDED_WARRANTY_SALES = 1000

/**
 * 年度任务名称 - 会员销量
 */
export const CSM_TASK_NAME_MEMBER_SALES = 1100

/**
 * 年度任务名称 - 套餐销量
 */
export const CSM_TASK_NAME_SET_OF_RUB_SALES = 1200

/**
 * 年度任务名称 - 续保销量
 */
export const CSM_TASK_NAME_RENEWAL_SALES = 1300

/**
 * 客户意见 - 服务人员态度不友好/不礼貌
 */
export const CSR_CUSTOMER_OPINION_SERVICE_STAFF_ATTITUDE_IS_NOT_FRIENDLY_IMPOLITE = 1039

/**
 * 客户意见 - 服务人员不可靠（不遵守承诺/欺骗用户）
 */
export const CSR_CUSTOMER_OPINION_SERVICE_PERSONNEL_ARE_UNRELIABLE_NOT_COMPLYING_WITH_PROMISES__DECEIVING_USERS = 1040

/**
 * 客户意见 - 不能有求必应/不耐心倾听您的要求并给予回应
 */
export const CSR_CUSTOMER_OPINION_CAN_N0T_BE_RESPONSIVE__IMPATIENT_TO_LISTEN_TO_YOUR_REQUEST_AND_RESPOND = 1041

/**
 * 客户意见 - 车辆维修/保养的工作内容解释不到位/不专业
 */
export const CSR_CUSTOMER_OPINION_THE_WORK_CONTENT_OF_VEHICLE_REPAIR_MAINTENANCE_IS_NOT_EXPLAINED_UNPROFESSIONAL = 1042

/**
 * 客户意见 - 服务站无人接待
 */
export const CSR_CUSTOMER_OPINION_SERVICE_STATION_NO_RECEPTION = 1043

/**
 * 客户意见 - 取车时无人协助
 */
export const CSR_CUSTOMER_OPINION_NO_ASSISTANCE_WHEN_PICKING_UP_THE_CAR = 1044

/**
 * 客户意见 - 服务站拒绝维修/拒绝服务
 */
export const CSR_CUSTOMER_OPINION_SERVICE_STATION_REFUSED_TO_REPAIR__REFUSE_SERVICE = 1045

/**
 * 客户意见 - 服务站未征得用户同意进行维修/保养
 */
export const CSR_CUSTOMER_OPINION_THE_SERVICE_STATION_DID_NOT_OBTAIN_THE_USER_S_CONSENT_FOR_REPAIR_MAINTENANCE = 1046

/**
 * 客户意见 - 服务人员服务建议不合理/质量不高
 */
export const CSR_CUSTOMER_OPINION_SERVICE_PERSONNEL_SERVICE_ADVICE_IS_UNREASONABLE_QUALITY_IS_NOT_HIGH = 1047

/**
 * 客户意见 - 服务站强行推销服务
 */
export const CSR_CUSTOMER_OPINION_SERVICE_STATION_FORCIBLE_MARKETING_SERVICE = 1048

/**
 * 客户意见 - 服务站不提供发票等文件/手续
 */
export const CSR_CUSTOMER_OPINION_THE_SERVICE_STATION_DOES_NOT_PROVIDE_INVOICES_AND_OTHER_DOCUMENTS_PROCEDURES = 1049

/**
 * 客户意见 - 服务站不让进入维修车间/不让接触维修人员
 */
export const CSR_CUSTOMER_OPINION_SERVICE_STATION_DOES_NOT_ALLOW_ACCESS_TO_THE_REPAIR_SHOP__NO_CONTACT_WITH_MAINTENANCE_PERSONNEL = 1050

/**
 * 客户意见 - 服务站没有及时跟进/告知维修/保养的进度
 */
export const CSR_CUSTOMER_OPINION_THE_SERVICE_STATION_DID_NOT_FOLLOW_UP_IN_TIME_INFORMED_OF_THE_PROGRESS_OF_REPAIR__MAINTENANCE = 1051

/**
 * 客户意见 - 14维修后无人联系/长时间无人联系
 */
export const CSR_CUSTOMER_OPINION_NO_CONTACT_AFTER_14_MAINTENANCE__NO_CONTACT_FOR_A_LONG_TIME = 1052

/**
 * 客户意见 - 15.电话回访方式不妥/希望有其他的回访形式
 */
export const CSR_CUSTOMER_OPINION_THE_WAY_TO_RETURN_TO_THE_PHONE_IS_NOT_APPROPRIATE__I_HOPE_THERE_ARE_OTHER_FORMS_OF_RETURNING = 1053

/**
 * 客户意见 - O2.1未介绍替代交通服务内容内容
 */
export const CSR_CUSTOMER_OPINION_NO_ALTERNATIVE_TRANSPORTATION_SERVICE_CONTENT_IS_INTRODUCED = 1000

/**
 * 客户意见 - O2.2未提供替代交通服务项目
 */
export const CSR_CUSTOMER_OPINION_NO_ALTERNATIVE_TRANSPORTATION_SERVICE_PROVIDED = 1001

/**
 * 客户意见 - O2.3替代交通服务收费不合理/价格高
 */
export const CSR_CUSTOMER_OPINION_ALTERNATIVE_TRANSPORTATION_SERVICE_CHARGES_ARE_UNREASONABLE_AND_HIGH_PRICE = 1002

/**
 * 客户意见 - O2.4提供的替代交通服务方式不满意（打车费少/提供车型配置低等)
 */
export const CSR_CUSTOMER_OPINION_DISSATISFIED_WITH_THE_ALTERNATIVE_TRANSPORTATION_SERVICE_PROVIDED = 1003

/**
 * 客户意见 - O3.1工时费价格高
 */
export const CSR_CUSTOMER_OPINION_HIGH_WORKING_HOURS = 1004

/**
 * 客户意见 - O3.2备件价格高
 */
export const CSR_CUSTOMER_OPINION_HIGH_SPARE_PARTS_PRICES = 1005

/**
 * 客户意见 - O3.3保养价格高
 */
export const CSR_CUSTOMER_OPINION_HIGH_MAINTENANCE_PRICE = 1006

/**
 * 客户意见 - O3.4维修价格高
 */
export const CSR_CUSTOMER_OPINION_HIGH_MAINTENANCE_PRICE_SERVICE = 1007

/**
 * 客户意见 - O3.5维修前未明确告知预计的维修/保养价格
 */
export const CSR_CUSTOMER_OPINION_UNEXPECTED_REPAIR_AND_MAINTENANCE_PRICE_IS_NOT_CLEARLY_STATED_BEFORE_REPAIR = 1008

/**
 * 客户意见 - O3.6服务项目及价格清单未能详尽地给予解释
 */
export const CSR_CUSTOMER_OPINION_SERVICE_ITEMS_AND_PRICE_LISTS_ARE_NOT_EXPLAINED_IN_DETAIL = 1009

/**
 * 客户意见 - O3.7保养/维修后的实际价格较预估价格变化较大/预估不准确
 */
export const CSR_CUSTOMER_OPINION_THE_ACTUAL_PRICE_AFTER_MAINTENANCE_AND_REPAIR_IS_LARGER_THAN_THE_ESTIMATED_PRICE_AND_PREDICTED_INACCURATE = 1010

/**
 * 客户意见 - O3.8服务收费不合理（收取不应有的费用）
 */
export const CSR_CUSTOMER_OPINION_SERVICE_CHARGES_ARE_UNREASONABLE = 1011

/**
 * 客户意见 - O4.1不能按照希望的时间进行预约
 */
export const CSR_CUSTOMER_OPINION_CA_NOT_MAKE_AN_APPOINTMENT_AT_THE_DESIRED_TIME = 1012

/**
 * 客户意见 - O4.2预约时间长
 */
export const CSR_CUSTOMER_OPINION_LONG_APPOINTMENT_TIME = 1013

/**
 * 客户意见 - O4.3送车时等待时间长
 */
export const CSR_CUSTOMER_OPINION_LONG_WAITING_TIME_WHEN_SENDING_A_CAR = 1014

/**
 * 客户意见 - O4.4保养时间长
 */
export const CSR_CUSTOMER_OPINION_LONG_MAINTENANCE_TIME = 1015

/**
 * 客户意见 - O4.5维修时间长
 */
export const CSR_CUSTOMER_OPINION_LONG_MAINTENANCE_TIME__SERVICE = 1016

/**
 * 客户意见 - O4.6备件等待时间长
 */
export const CSR_CUSTOMER_OPINION_LONG_WAITING_TIME_FOR_SPARE_PARTS = 1017

/**
 * 客户意见 - O4.7维修/保养时间超出了承诺时间/不能按时交接车辆
 */
export const CSR_CUSTOMER_OPINION_REPAIR_AND_MAINTENANCE_TIME_EXCEEDS_PROMISED_TIME_AND_CANNOT_DELIVER_VEHICLE_ON_TIME = 1018

/**
 * 客户意见 - O4.8救援时间长
 */
export const CSR_CUSTOMER_OPINION_LONG_RESCUE_TIME = 1019

/**
 * 客户意见 - O4.9保险办理时间长
 */
export const CSR_CUSTOMER_OPINION_LONG_INSURANCE_PROCESSING_TIME = 1020

/**
 * 客户意见 - O4.10手续办理及交接时间长（填写单据、签字等环节）
 */
export const CSR_CUSTOMER_OPINION_LONG_PROCEDURE_AND_HANDOVER_TIME = 1021

/**
 * 客户意见 - O4.11取车时等待时间长
 */
export const CSR_CUSTOMER_OPINION_LONG_WAITING_TIME_WHEN_PICKING_UP_THE_CAR = 1022

/**
 * 客户意见 - O4.12洗车时间长
 */
export const CSR_CUSTOMER_OPINION_LONG_CAR_WASH_TIME = 1023

/**
 * 客户意见 - O5.1车辆故障检测不出来/诊断有误
 */
export const CSR_CUSTOMER_OPINION_VEHICLE_FAILURE_DETECTION_IS_NOT_DETECTED_AND_DIAGNOSIS_IS_INCORRECT = 1024

/**
 * 客户意见 - O5.2维修/保养不彻底/故障未解决
 */
export const CSR_CUSTOMER_OPINION_REPAIR_AND_MAINTENANCE_IS_NOT_COMPLETE_AND_FAULT_IS_NOT_RESOLVED = 1025

/**
 * 客户意见 - O5.2维修/保养车辆被返修/重修
 */
export const CSR_CUSTOMER_OPINION_REPAIR_MAINTENANCE_IS_NOT_COMPLETE_FAULT_IS_NOT_RESOLVED = 1025

/**
 * 客户意见 - O5.3保养/维修后的车辆不干净/不整洁
 */
export const CSR_CUSTOMER_OPINION_MAINTENANCE_AND_REPAIR_OF_THE_VEHICLE_IS_NOT_CLEAN_AND_UNTIDY = 1026

/**
 * 客户意见 - O5.4维修/保养后车辆出现新故障
 */
export const CSR_CUSTOMER_OPINION_NEW_FAULT_IN_THE_VEHICLE_AFTER_REPAIR_AND_MAINTENANCE = 1027

/**
 * 客户意见 - O5.5服务人员维修/保养工作不专业
 */
export const CSR_CUSTOMER_OPINION_SERVICE_PERSONNEL_REPAIR_AND_MAINTENANCE_WORK_IS_NOT_PROFESSIONAL = 1028

/**
 * 客户意见 - O5.6维修/保养后车辆在站内被使用/损坏/改变车辆设置
 */
export const CSR_CUSTOMER_OPINION_VEHICLE_USED_AND_DAMAGED_AND_CHANGED_VEHICLE_SETTINGS_AFTER_REPAIR_AND_MAINTENANCE = 1029

/**
 * 客户意见 - O5.7未能完成要求的项目
 */
export const CSR_CUSTOMER_OPINION_FAILED_TO_COMPLETE_THE_REQUESTED_PROJECT = 1030

/**
 * 客户意见 - O5.8维修/保养方案不合理
 */
export const CSR_CUSTOMER_OPINION_REPAIR_AND_MAINTENANCE_PLAN_IS_UNREASONABLE = 1031

/**
 * 客户意见 - O6.1地理位置不便利
 */
export const CSR_CUSTOMER_OPINION_LOCATION_IS_NOT_CONVENIENT = 1032

/**
 * 客户意见 - O6.2进出经销店不方便
 */
export const CSR_CUSTOMER_OPINION_IS_INCONVENIENT_TO_ENTER_AND_EXIT_THE_DEALERSHIP = 1033

/**
 * 客户意见 - O6.3车辆在服务站停放不方便
 */
export const CSR_CUSTOMER_OPINION_VEHICLES_ARE_NOT_CONVENIENT_TO_PARK_AT_THE_SERVICE_STATION = 1034

/**
 * 客户意见 - O6.3客户休息区环境不舒适/设施不齐全
 */
export const CSR_CUSTOMER_OPINION_CUSTOMER_LOUNGE_AREA_IS_NOT_COMFORTABLE_AND_FACILITIES_ARE_NOT_COMPLETE = 1035

/**
 * 客户意见 - O6.4维修站的食物/饮品不满意
 */
export const CSR_CUSTOMER_OPINION_REPAIR_STATION_FOOD_AND_DRINK_IS_NOT_SATISFIED = 1036

/**
 * 客户意见 - O6.5整体环境设施不干净
 */
export const CSR_CUSTOMER_OPINION_OVERALL_ENVIRONMENTAL_FACILITIES_ARE_NOT_CLEAN = 1038

/**
 * 客户意见 - 7.1财务
 */
export const CSR_CUSTOMER_OPINION_FINANCE = 1039

/**
 * 客户意见 - 7.2食堂
 */
export const CSR_CUSTOMER_OPINION_CANTEEN = 1040

/**
 * 回访状态 - 空号
 */
export const CSR_ACCESS_PHONE_STATUS_EMPTY_NUMBER = 900

/**
 * 回访状态 - 挂断
 */
export const CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_HANG_UP = 1000

/**
 * 回访状态 - 关机
 */
export const CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_SHUT_DOWN = 1001

/**
 * 回访状态 - 拒访
 */
export const CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_REFUSAL = 1002

/**
 * 回访状态 - 时间不宜
 */
export const CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_TIME_IS_NOT_APPROPRIATE = 1003

/**
 * 回访状态 - 停机
 */
export const CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_DOWNTIME = 1004

/**
 * 回访状态 - 无法接通
 */
export const CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_UNABLE_TO_CONNECT = 1005

/**
 * 回访状态 - 无人接听
 */
export const CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_NO_ONE_HEARD = 1006

/**
 * 回访状态 - 占线
 */
export const CSR_ACCESS_PHONE_STATUS_PHONE_STATUS_BUSY = 1007

/**
 * 销售类型 - 成功
 */
export const CSM_PACKAGE_SALE_TYPE_SALE_MAINTAIN_PACKAGE = 1001

/**
 * 销售类型 - 战败
 */
export const CSM_PACKAGE_SALE_TYPE_SALE_FAIL_PACKAGE = 1003

/**
 * 备件状态 - 正常
 */
export const CSM_PARTS_STATUS_PARTS_STATUS_NORMAL = 1001

/**
 * 备件状态 - 订件
 */
export const CSM_PARTS_STATUS_PARTS_STATUS_ORDER = 1002

/**
 * 备件状态 - 到货
 */
export const CSM_PARTS_STATUS_PARTS_STATUS_ARRIVAL = 1003

/**
 * 是否有效 - 有效
 */
export const UCT_VALIDITY_VALID = 1

/**
 * 是否有效 - 无效
 */
export const UCT_VALIDITY_INVALID = 2

/**
 * 商机阶段 - 二次洽谈
 */
export const UCT_CARRIED_OUT_STATUS_SECOND_NEGOTIATION = 1000

/**
 * 商机阶段 - 三次洽谈
 */
export const UCT_CARRIED_OUT_STATUS_THREE_TALKS = 2000

/**
 * 商机阶段 - 多次洽谈
 */
export const UCT_CARRIED_OUT_STATUS_NEGOTIATE_MANY_TIMES = 3000

/**
 * 商机阶段 - 成单
 */
export const UCT_CARRIED_OUT_STATUS_INTO_A_SINGLE = 4000

/**
 * 商机阶段 - 战败
 */
export const UCT_CARRIED_OUT_STATUS_DEFEATED = 5000

/**
 * 商机类型 - 换购
 */
export const UCT_COMMERCIAL_OPPORTUNITY_TYPE_REDEMPTION = 1000

/**
 * 商机类型 - 收购
 */
export const UCT_COMMERCIAL_OPPORTUNITY_TYPE_ACQUISITION = 2000

/**
 * 商机类型 - 售车
 */
export const UCT_COMMERCIAL_OPPORTUNITY_TYPE_CAR_SALES = 3000

/**
 * 商机来源 - 售后
 */
export const UCT_COMMERCIAL_OPPORTUNITY_SOURCE_AFTER_SALE = 1000

/**
 * 商机来源 - 展厅
 */
export const UCT_COMMERCIAL_OPPORTUNITY_SOURCE_SHOWROOM = 2000

/**
 * 商机来源 - 网络
 */
export const UCT_COMMERCIAL_OPPORTUNITY_SOURCE_THE_INTERNET = 3000

/**
 * 商机来源 - 社会
 */
export const UCT_COMMERCIAL_OPPORTUNITY_SOURCE_SOCIETY = 4000

/**
 * 车身颜色 - 黑色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_BLACK = 1000

/**
 * 车身颜色 - 白色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_WHITE = 1001

/**
 * 车身颜色 - 银灰色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_SILVER_GREY = 1002

/**
 * 车身颜色 - 深灰色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_DARK_GRAY = 1003

/**
 * 车身颜色 - 红色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_RED = 1004

/**
 * 车身颜色 - 蓝色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_BLUE = 1005

/**
 * 车身颜色 - 绿色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_GREEN = 1006

/**
 * 车身颜色 - 黄色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_YELLOW = 1007

/**
 * 车身颜色 - 香槟色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_CHAMPAGNE = 1008

/**
 * 车身颜色 - 紫色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_PURPLE = 1009

/**
 * 车身颜色 - 橙色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_ORANGE = 1010

/**
 * 车身颜色 - 棕色
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_BROWN = 1011

/**
 * 车身颜色 - 其他
 */
export const UCT_CURRENT_THE_COLOR_OF_CAR_OTHER = 1012

/**
 * 燃油类型 - 汽油
 */
export const UCT_FUEL_TYPE_GASOLINE = 1000

/**
 * 燃油类型 - 柴油
 */
export const UCT_FUEL_TYPE_DIESEL = 2000

/**
 * 燃油类型 - 混动
 */
export const UCT_FUEL_TYPE_HYBRID = 3000

/**
 * 燃油类型 - 电动
 */
export const UCT_FUEL_TYPE_ELECTRIC = 4000

/**
 * 排放标准 - 国II
 */
export const UCT_CURRENT_EMISSION_STANDARDS_COUNTRY_TWO = 1000

/**
 * 排放标准 - 国III
 */
export const UCT_CURRENT_EMISSION_STANDARDS_COUNTRY_THREE = 1001

/**
 * 排放标准 - 国IV
 */
export const UCT_CURRENT_EMISSION_STANDARDS_COUNTRY_FOUR = 1002

/**
 * 排放标准 - 国V
 */
export const UCT_CURRENT_EMISSION_STANDARDS_COUNTRY_FIVES = 1003

/**
 * 排放标准 - 国VI
 */
export const UCT_CURRENT_EMISSION_STANDARDS_COUNTRY_SIX = 1004

/**
 * 排放标准 - 欧II
 */
export const UCT_CURRENT_EMISSION_STANDARDS_EURO_TWO = 1005

/**
 * 排放标准 - 欧III
 */
export const UCT_CURRENT_EMISSION_STANDARDS_EURO_THREE = 1006

/**
 * 排放标准 - 欧IV
 */
export const UCT_CURRENT_EMISSION_STANDARDS_EURO_FOUR = 1007

/**
 * 排放标准 - 欧V
 */
export const UCT_CURRENT_EMISSION_STANDARDS_EURO_FIVES = 1008

/**
 * 排放标准 - 欧VI
 */
export const UCT_CURRENT_EMISSION_STANDARDS_EURO_SIX = 1009

/**
 * 驱动方式 - 前驱
 */
export const UCT_CURRENT_DRIVING_METHOD_PRECURSOR = 1000

/**
 * 驱动方式 - 后驱
 */
export const UCT_CURRENT_DRIVING_METHOD_REAR_DRIVE = 2000

/**
 * 驱动方式 - 四驱
 */
export const UCT_CURRENT_DRIVING_METHOD_FOUR_WHEEL_DRIVE = 3000

/**
 * 通话状态 - 有效沟通
 */
export const UCT_CALL_STATUS_VALID_INTERVIEW = 1000

/**
 * 通话状态 - 无效沟通
 */
export const UCT_CALL_STATUS_INVALID_INTERVIEW = 1003

/**
 * 线索状态 - 跟踪
 */
export const UCT_CLUE_STATUS_TRACK = 1000

/**
 * 线索状态 - 成功
 */
export const UCT_CLUE_STATUS_SUCCESS = 2000

/**
 * 线索状态 - 战败
 */
export const UCT_CLUE_STATUS_DEFEATED = 3000

/**
 * 战败原因 - 车主不想卖
 */
export const UCT_REASON_FOR_FAILURE_CAR_OWNERS_DO_NOT_WANT_TO_SELL = 1000

/**
 * 战败原因 - 车已卖
 */
export const UCT_REASON_FOR_FAILURE_CAR_SOLD = 2000

/**
 * 商机状态 - 待确认
 */
export const UCT_COMMERCIAL_OPPORTUNITY_STATUS_TO_BE_CONFIRMED = 1000

/**
 * 商机状态 - 已确认
 */
export const UCT_COMMERCIAL_OPPORTUNITY_STATUS_CONFIRMED = 1001

/**
 * 商机状态 - 有效
 */
export const UCT_COMMERCIAL_OPPORTUNITY_STATUS_EFFECTIVE = 1002

/**
 * 商机状态 - 无效
 */
export const UCT_COMMERCIAL_OPPORTUNITY_STATUS_INVALID = 1003

/**
 * 商机执行状态 - 待执行
 */
export const UCT_OPPORTUNITY_EXECUTION_STATUS_PENDING = 1000

/**
 * 商机执行状态 - 已完成
 */
export const UCT_OPPORTUNITY_EXECUTION_STATUS_COMPLETED = 2000

/**
 * 商机执行状态 - 超期
 */
export const UCT_OPPORTUNITY_EXECUTION_STATUS_OVERDUE = 3000

/**
 * 变速箱 - 手动
 */
export const UCT_CEARBOX_MANUAL = 1000

/**
 * 变速箱 - 自动
 */
export const UCT_CEARBOX_AUTOMATIC = 2000

/**
 * 精品活动战败原因 - 不需要
 */
export const CSM_REASONS_FOR_DEFEAT_IN_BOUTIQUE_ACTIVITIES_NO_NEED = 1000

/**
 * 精品活动战败原因 - 已经安装
 */
export const CSM_REASONS_FOR_DEFEAT_IN_BOUTIQUE_ACTIVITIES_ALREADY_INSTALLED = 2000

/**
 * 精品活动战败原因 - 价格高
 */
export const CSM_REASONS_FOR_DEFEAT_IN_BOUTIQUE_ACTIVITIES_HIGH_PRICE = 3000

/**
 * 续保战败原因 - 外地车
 */
export const CAUSE_OF_DEFEAT_FIELD_CAR = 1000

/**
 * 续保战败原因 - 已过户
 */
export const CAUSE_OF_DEFEAT_TRANSFERRED = 1001

/**
 * 续保战败原因 - 承保限制
 */
export const CAUSE_OF_DEFEAT_COVERAGE_RESTRICTIONS = 1002

/**
 * 续保战败原因 - 电话有误
 */
export const CAUSE_OF_DEFEAT_WRONG_CALL = 1003

/**
 * 续保战败原因 - 明确拒保
 */
export const CAUSE_OF_DEFEAT_EXPRESS_DENIAL = 1004

/**
 * 续保战败原因 - 同城价格
 */
export const CAUSE_OF_DEFEAT_SAME_CITY_PRICE = 1005

/**
 * 续保战败原因 - 人情保
 */
export const CAUSE_OF_DEFEAT_HUMAN_SECURITY = 1006

/**
 * 续保战败原因 - 其他
 */
export const CAUSE_OF_DEFEAT_OTHER = 1007

/**
 * 续保战败原因 - 已投保
 */
export const CAUSE_OF_DEFEAT_INSURED = 1008

/**
 * 续保战败原因 - 壁虎无法算价
 */
export const CAUSE_OF_DEFEAT_GECKO_CAN_NOT_COUNT = 1009

/**
 * 续保战败原因 - 同城代理
 */
export const CAUSE_OF_DEFEAT_CITY_AGENT = 1010

/**
 * 续保战败原因 - 同城电销
 */
export const CAUSE_OF_DEFEAT_TELEMARKETING_IN_THE_SAME_CITY = 1011

/**
 * 续保战败原因 - 同城4S店
 */
export const CAUSE_OF_DEFEAT_4S_SHOP_IN_THE_SAME_CITY = 1012

/**
 * 续保战败原因 - 同城业务大厅
 */
export const CAUSE_OF_DEFEAT_CITY_HALL = 1013

/**
 * 续保战败原因 - 不告诉价格原因
 */
export const CAUSE_OF_DEFEAT_DO_NOT_TELL_THE_PRICE_REASON = 1014

/**
 * 续保战败原因 - 省内非吉A牌
 */
export const CAUSE_OF_DEFEAT_FEIJI_A_BRAND_IN_THE_PROVINCE = 1015

/**
 * 续保战败原因 - 省外牌
 */
export const CAUSE_OF_DEFEAT_PROVINCIAL_BRAND = 1016

/**
 * 续保战败原因 - 车龄超10年
 */
export const CAUSE_OF_DEFEAT_10_YEARS_OLD = 1017

/**
 * 客户类别 - A类客户
 */
export const CSM_CUSTOMER_TYPE_A = 1000

/**
 * 客户类别 - B类客户
 */
export const CSM_CUSTOMER_TYPE_B = 2000

/**
 * 客户类别 - C类客户
 */
export const CSM_CUSTOMER_TYPE_C = 3000

/**
 * 客户类别 - D类客户
 */
export const CSM_CUSTOMER_TYPE_D = 4000

/**
 * 新增客户类别 - 他店新增
 */
export const CSM_ADD_CUSTOMER_TYPE_ADDED_IN_OTHER_STORES = 1000

/**
 * 新增客户类别 - 销售新增
 */
export const CSM_ADD_CUSTOMER_TYPE_NEW_SALES = 2000

/**
 * 新增客户类别 - 流失挽回
 */
export const CSM_ADD_CUSTOMER_TYPE_CHURN = 3000

/**
 * 新增客户类别 - 外来客户
 */
export const CSM_ADD_CUSTOMER_TYPE_FOREIGN_CUSTOMERS = 4000

/**
 * 购车日期按月查询条件 - 1月
 */
export const DATE_OF_PURCHASE_BY_MONTH_JANUARY = '-01-'

/**
 * 购车日期按月查询条件 - 2月
 */
export const DATE_OF_PURCHASE_BY_MONTH_FEBRUARY = '-02-'

/**
 * 购车日期按月查询条件 - 3月
 */
export const DATE_OF_PURCHASE_BY_MONTH_MARCH = '-03-'

/**
 * 购车日期按月查询条件 - 4月
 */
export const DATE_OF_PURCHASE_BY_MONTH_APRIL = '-04-'

/**
 * 购车日期按月查询条件 - 5月
 */
export const DATE_OF_PURCHASE_BY_MONTH_MAY = '-05-'

/**
 * 购车日期按月查询条件 - 6月
 */
export const DATE_OF_PURCHASE_BY_MONTH_JUNE = '-06-'

/**
 * 购车日期按月查询条件 - 7月
 */
export const DATE_OF_PURCHASE_BY_MONTH_JULY = '-07-'

/**
 * 购车日期按月查询条件 - 8月
 */
export const DATE_OF_PURCHASE_BY_MONTH_AUGUST = '-08-'

/**
 * 购车日期按月查询条件 - 9月
 */
export const DATE_OF_PURCHASE_BY_MONTH_SEPTEMBER = '-09-'

/**
 * 购车日期按月查询条件 - 10月
 */
export const DATE_OF_PURCHASE_BY_MONTH_OCTOBER = '-10-'

/**
 * 购车日期按月查询条件 - 11月
 */
export const DATE_OF_PURCHASE_BY_MONTH_NOVEMBER = '-11-'

/**
 * 购车日期按月查询条件 - 12月
 */
export const DATE_OF_PURCHASE_BY_MONTH_DECEMBER = '-12-'

/**
 * 销售状态 - 待跟踪
 */
export const IIM_LAST_SALE_STATUS_CUSTOMER_RELATION_TRACK = 1000

/**
 * 销售状态 - 交商共保
 */
export const IIM_LAST_SALE_STATUS_CUSTOMER_RELATION_SUCCESS = 1100

/**
 * 销售状态 - 战败
 */
export const IIM_LAST_SALE_STATUS_CUSTOMER_RELATION_DEFEATED = 1200

/**
 * 销售状态 - 单交强
 */
export const IIM_LAST_SALE_STATUS_SINGLE_CROSS_STRONG = 1300

/**
 * 销售状态 - 单商业
 */
export const IIM_LAST_SALE_STATUS_SINGLE_BUSINESS = 1400

/**
 * 日志类型 - 通话
 */
export const IIM_TYPE_CALL = 1000

/**
 * 日志类型 - 分配
 */
export const IIM_TYPE_DISTRIBUTION = 2000

/**
 * 沟通事项 - 提醒进店
 */
export const CSM_COMMUNICATION_MATTERS_REMIND_TO_ENTER_THE_STORE = 1000

/**
 * 沟通事项 - 销售PLUS
 */
export const CSM_COMMUNICATION_MATTERS_SALE_PLUS = 2000

/**
 * 沟通事项 - 到期提醒
 */
export const CSM_COMMUNICATION_MATTERS_EXPIRATION_REMINDER = 3000

/**
 * 延保状态 - 待提醒
 */
export const CSM_EXTENSION_STATUS_TO_BE_REMINDED = 1000

/**
 * 延保状态 - 提醒中
 */
export const CSM_EXTENSION_STATUS_REMINDING = 2000

/**
 * 延保状态 - 已终止
 */
export const CSM_EXTENSION_STATUS_TERMINATED = 3000

/**
 * 延保状态 - 已索赔
 */
export const CSM_EXTENSION_STATUS_CLAIMED = 4000

/**
 * 问卷类型 - 保养
 */
export const SURVEY_PAGER_TYPE_MAINTENANCE = 1000

/**
 * 问卷类型 - 首保
 */
export const SURVEY_PAGER_TYPE_FIRST_GUARANTEE = 2000

/**
 * 问卷类型 - 事故
 */
export const SURVEY_PAGER_TYPE_ACCIDENT = 3000

/**
 * 问卷类型 - 潜客
 */
export const SURVEY_PAGER_TYPE_POTENTIAL_CUSTOMER = 4000

/**
 * 问题类型 - 单选
 */
export const SURVEY_OPTION_TYPE_RADIO = 1000

/**
 * 问题类型 - 多选
 */
export const SURVEY_OPTION_TYPE_MULTIPLE_CHOICE = 2000

/**
 * 问题类型 - 填空题
 */
export const SURVEY_OPTION_TYPE_FILL_IN_THE_BLANKS = 3000

/**
 * 问题类型 - 问答题
 */
export const SURVEY_OPTION_TYPE_QUESTIONS_AND_ANSWERS = 4000

/**
 * 问卷状态 - 使用中
 */
export const SURVEY_PAGER_STATUS_USING = 1000

/**
 * 问卷状态 - 停用
 */
export const SURVEY_PAGER_STATUS_DEACTIVATE = 2000

/**
 * 问卷状态 - 草稿
 */
export const SURVEY_PAGER_STATUS_DRAFT = 3000

/**
 * 认证方式 - 自动
 */
export const MEMBER_VERIFICATION_MANNER_AUTOMATIC = 1000

/**
 * 认证方式 - 审批
 */
export const MEMBER_VERIFICATION_MANNER_APPROVAL = 2000

/**
 * 认证状态 - 未认证
 */
export const MEMBER_VERIFICATION_STATUS_NOT_APPROVED = 1000

/**
 * 认证状态 - 待审批
 */
export const MEMBER_VERIFICATION_STATUS_PENDING = 2000

/**
 * 认证状态 - 已认证
 */
export const MEMBER_VERIFICATION_STATUS_PASSED = 3000

/**
 * 认证状态 - 驳回
 */
export const MEMBER_VERIFICATION_STATUS_TURN_DOWN = 4000

/**
 * 卡券类型 - 满减券
 */
export const COUPON_CUPON_TYPE_FULL_COUPON = 1000

/**
 * 卡券类型 - 折扣券
 */
export const COUPON_CUPON_TYPE_DISCOUNT_COUPON = 2000

/**
 * 卡券类型 - 抵扣券
 */
export const COUPON_CUPON_TYPE_VOUCHER = 3000

/**
 * 卡券类型 - 套餐券
 */
export const COUPON_CUPON_TYPE_PACKAGE_VOUCHER = 4000

/**
 * 卡券定义状态 - 启用
 */
export const COUPON_DEFINITION_STATUS_ENABLE = 1000

/**
 * 卡券定义状态 - 停用
 */
export const COUPON_DEFINITION_STATUS_DEACTIVATE = 2000

/**
 * 卡券定义状态 - 草稿
 */
export const COUPON_DEFINITION_STATUS_DRAFT = 3000

/**
 * 卡券到期类型 - 固定时间有效
 */
export const COUPON_EXPIRES_TYPE_EFFECTIVE_AT_FIXED_TIME = 1000

/**
 * 卡券到期类型 - 领取后时间长度有效
 */
export const COUPON_EXPIRES_TYPE_THE_LENGTH_OF_TIME_AFTER_RECEIPT_IS_VALID = 2000

/**
 * 卡券到期类型 - 长期有效
 */
export const COUPON_EXPIRES_TYPE_LONG_TERM_EFFECTIVE = 3000

/**
 * 购买类型 - 赠送
 */
export const APPLICATION_TYPE_GIVE_AWAY = 1000

/**
 * 购买类型 - 购买
 */
export const APPLICATION_TYPE_BUY = 2000

/**
 * 核销方式 - 卡券核销
 */
export const CANCELLATION_AFTER_VERIFICATION_TYPE_CARD_COUPON_VERIFICATION = 1000

/**
 * 核销方式 - 卡券与现金核销
 */
export const CANCELLATION_AFTER_VERIFICATION_TYPE_COUPONS_AND_CASH_WRITE_OFFS = 2000

/**
 * 核销方式 - 单储值卡扣除
 */
export const CANCELLATION_AFTER_VERIFICATION_TYPE_SINGLE_STORED_VALUE_CARD_DEDUCTION = 3000

/**
 * 核销方式 - 卡券与储值核销
 */
export const CANCELLATION_AFTER_VERIFICATION_TYPE_COUPONS_AND_STORED_VALUE_VERIFICATION = 4000

/**
 * 核销方式 - 卡券、储值与现金核销
 */
export const CANCELLATION_AFTER_VERIFICATION_TYPE_CARDS_STORED_VALUE_AND_CASH_WRITE_OFF = 5000

/**
 * 会员来源 - 门店
 */
export const MEMBER_MEMBER_SOURCE_STORE = 1000

/**
 * 会员来源 - 公众号
 */
export const MEMBER_MEMBER_SOURCE_NO_PUBLIC = 2000

/**
 * 卡券使用状态 - 未核销
 */
export const COUPON_USE_STATUS_UNWRITTEN = 1000

/**
 * 卡券使用状态 - 已核销
 */
export const COUPON_USE_STATUS_WRITTEN_OFF = 2000

/**
 * 卡券使用状态 - 已过期
 */
export const COUPON_USE_STATUS_EXPIRED = 3000

/**
 * 核销地点 - 店内
 */
export const VERIFY_SALES_LOCATION_IN_STORE = 1000

/**
 * 核销地点 - 外出
 */
export const VERIFY_SALES_LOCATION_GO_OUT = 2000

/**
 * 审批选项 - 通过
 */
export const APPROVAL_OPTIONS_PASSED = 3000

/**
 * 审批选项 - 驳回
 */
export const APPROVAL_OPTIONS_TURN_DOWN = 4000

/**
 * 处理状态 - 已处理
 */
export const HANDLE_STATUS_ALREADY_PROCESSED = 1000

/**
 * 处理状态 - 未处理
 */
export const HANDLE_STATUS_UNPROCESSED = 2000

/**
 * 是否有效 - 有效
 */
export const IS_EFFECTIVE_EFFECTIVE = 1000

/**
 * 是否有效 - 无效
 */
export const IS_EFFECTIVE_INVALID = 2000

/**
 * 卡券定义审批状态 - 未审批
 */
export const COUPON_DEFINITION_APPROVE_STATUS_NOT_APPROVED = 1000

/**
 * 卡券定义审批状态 - 待审批
 */
export const COUPON_DEFINITION_APPROVE_STATUS_PENDING = 2000

/**
 * 卡券定义审批状态 - 通过
 */
export const COUPON_DEFINITION_APPROVE_STATUS_BY = 3000

/**
 * 卡券定义审批状态 - 驳回
 */
export const COUPON_DEFINITION_APPROVE_STATUS_TURN_DOWN = 4000

/**
 * 卡券发放审批状态 - 未审批
 */
export const COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS_NOT_APPROVED = 1000

/**
 * 卡券发放审批状态 - 待审批
 */
export const COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS_PENDING = 2000

/**
 * 卡券发放审批状态 - 已通过
 */
export const COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS_PASSED = 3000

/**
 * 卡券发放审批状态 - 已驳回
 */
export const COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS_TURN_DOWN = 4000

/**
 * 卡券发放审批状态 - 作废
 */
export const COUPON_COUPON_INSTANCE_BUY_APPROVE_STATUS_BECOME_INVALID = 5000

/**
 * 金融项目定义状态 - 启用
 */
export const FINANCIAL_PROJECT_DEFINITION_STATUS_ENABLED = 1000

/**
 * 金融项目定义状态 - 停用
 */
export const FINANCIAL_PROJECT_DEFINITION_STATUS_DISABLED = 2000

/**
 * 金融项目定义状态 - 草稿
 */
export const FINANCIAL_PROJECT_DEFINITION_STATUS_DRAFT = 3000

/**
 * 产品类型 - 储值
 */
export const MEMBER_PRODUCT_TYPE_RECHARGE = 1000

/**
 * 产品类型 - 卡券
 */
export const MEMBER_PRODUCT_TYPE_COUPON = 2000

/**
 * 产品类型 - 金融项目
 */
export const MEMBER_PRODUCT_TYPE_FINANCE_PROJECT = 3000

/**
 * 会员储值记录类型 - 充值
 */
export const MEMBER_STORED_VALUE_RECORD_TYPE_TOP_UP = 1000

/**
 * 会员储值记录类型 - 核销
 */
export const MEMBER_STORED_VALUE_RECORD_TYPE_WRITE_OFF = 2000

/**
 * 会员储值记录类型 - 商城兑换
 */
export const MEMBER_STORED_VALUE_RECORD_TYPE_MALL_REDEMPTION = 3000

/**
 * 婚姻 - 未婚
 */
export const MARITAL_STATUS_UNMARRIED = 1000

/**
 * 婚姻 - 已婚无小孩
 */
export const MARITAL_STATUS_MARRIED_WITHOUT_CHILDREN = 2000

/**
 * 婚姻 - 已婚有小孩
 */
export const MARITAL_STATUS_MARRIED_WITH_CHILDREN = 3000

/**
 * 职业 - 公务员
 */
export const OCCUPATION_CIVIL_SERVANT = 1000

/**
 * 职业 - 中高级管理人员
 */
export const OCCUPATION_SENIOR_MANAGEMENT = 1001

/**
 * 职业 - 中高级技术人员
 */
export const OCCUPATION_SENIOR_TECHNICAL_STAFF = 1002

/**
 * 职业 - 私营业主
 */
export const OCCUPATION_PRIVATE_OWNERS = 1003

/**
 * 职业 - 教师
 */
export const OCCUPATION_TEACHER = 1004

/**
 * 职业 - 自由职业者
 */
export const OCCUPATION_FREELANCERS = 1005

/**
 * 职业 - 销售人员
 */
export const OCCUPATION_SALESPERSON = 1006

/**
 * 职业 - 医生
 */
export const OCCUPATION_DOCTORS = 1007

/**
 * 职业 - 公司职员
 */
export const OCCUPATION_STAFF = 1008

/**
 * 职业 - 其他
 */
export const OCCUPATION_OTHER = 1010

/**
 * 月收入 - 3000
 */
export const MONTHLY_INCOME_3000 = 1000

/**
 * 月收入 - 3000-8000
 */
export const MONTHLY_INCOME_3000_8000 = 1001

/**
 * 月收入 - 8000-15000
 */
export const MONTHLY_INCOME_8000_15000 = 1002

/**
 * 月收入 - 15000以上
 */
export const MONTHLY_INCOME_15000_OR_MORE = 1003

/**
 * 兴趣爱好 - 电影
 */
export const HOBBY_THE_FILM = 1000

/**
 * 兴趣爱好 - 音乐
 */
export const HOBBY_MUSIC = 1001

/**
 * 兴趣爱好 - 运动
 */
export const HOBBY_MOTION = 1002

/**
 * 兴趣爱好 - 看书
 */
export const HOBBY_READING = 1003

/**
 * 兴趣爱好 - 购物
 */
export const HOBBY_SHOPPING = 1004

/**
 * 兴趣爱好 - 旅游
 */
export const HOBBY_TOURISM = 1005

/**
 * 兴趣爱好 - 电子产品
 */
export const HOBBY_ELECTRONIC_PRODUCT = 1006

/**
 * 兴趣爱好 - 上网
 */
export const HOBBY_GO_ONLINE = 1007

/**
 * 兴趣爱好 - 收藏
 */
export const HOBBY_COLLECT = 1008

/**
 * 兴趣爱好 - 棋牌
 */
export const HOBBY_CHESS = 1009

/**
 * 兴趣爱好 - 聚会
 */
export const HOBBY_GET_TOGETHER = 1010

/**
 * 兴趣爱好 - 游戏
 */
export const HOBBY_GAME = 1011

/**
 * 兴趣爱好 - 摄影
 */
export const HOBBY_PHOTOGRAPHY = 1012

/**
 * 兴趣爱好 - 其他
 */
export const HOBBY_OTHER = 1013

/**
 * 车辆用途 - 上下班
 */
export const VEHICLE_USE_COMMUTE = 1000

/**
 * 车辆用途 - 公事
 */
export const VEHICLE_USE_OFFICIAL_BUSINESS = 1001

/**
 * 车辆用途 - 休闲
 */
export const VEHICLE_USE_LEISURE = 1002

/**
 * 车辆用途 - 其他
 */
export const VEHICLE_USE_OTHER = 1003

/**
 * 年龄 - 20以下
 */
export const AGE_20_OR_LESS = 1000

/**
 * 年龄 - 20-25
 */
export const AGE_20_25 = 1001

/**
 * 年龄 - 25-30
 */
export const AGE_25_30 = 1002

/**
 * 年龄 - 30-35
 */
export const AGE_30_35 = 1003

/**
 * 年龄 - 40-45
 */
export const AGE_40_45 = 1004

/**
 * 年龄 - 45-50
 */
export const AGE_45_50 = 1005

/**
 * 年龄 - 50以上
 */
export const AGE_ABOVE_50 = 1006

/**
 * 回访电话状态 - 接通
 */
export const CSR_CALL_STATUS_TURN_ON = 1000

/**
 * 回访电话状态 - 未接通
 */
export const CSR_CALL_STATUS_NOT_CONNECTED = 2000

/**
 * 回访回访状态 - 成功
 */
export const CSR_ACCESS_STATUS_SUCCESS = 1000

/**
 * 回访回访状态 - 失败
 */
export const CSR_ACCESS_STATUS_FAILURE = 2000

/**
 * 事故统计保险公司 - 平安
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_SAFE = '平安'

/**
 * 事故统计保险公司 - 人保
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_PEOPLE_IS_INSURANCE = '人保'

/**
 * 事故统计保险公司 - 太平洋
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_THE_PACIFIC_OCEAN = '太平洋'

/**
 * 事故统计保险公司 - 大地
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_EARTH = '大地'

/**
 * 事故统计保险公司 - 鑫安
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_XIN_AN = '鑫安'

/**
 * 事故统计保险公司 - 四平人保 
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_SIPING_PEOPLE_IS_INSURANCE = '四平人保 '

/**
 * 事故统计保险公司 - 安华
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_ANWAR = '安华'

/**
 * 事故统计保险公司 - 阳光
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_SUNLIGHT = '阳光'

/**
 * 事故统计保险公司 - 华安
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_HUAAN = '华安'

/**
 * 事故统计保险公司 - 天安
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_TIAN_AN = '天安'

/**
 * 事故统计保险公司 - 华泰
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_HUATAI = '华泰'

/**
 * 事故统计保险公司 - 安邦/大家
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_ANBANG_EVERYONE = '安邦@@大家'

/**
 * 事故统计保险公司 - 都邦
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_DUBANG = '都邦'

/**
 * 事故统计保险公司 - 永成
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_YONGCHENG = '永成@@永城'

/**
 * 事故统计保险公司 - 安盟
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_UNITA = '安盟'

/**
 * 事故统计保险公司 - 中华联合
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_CHINA_UNITED = '中华联合'

/**
 * 事故统计保险公司 - 太平
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_TAIPING = '太平'

/**
 * 事故统计保险公司 - 亚泰
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_YATAI = '亚泰'

/**
 * 事故统计保险公司 - 英大
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_YINGDA = '英大'

/**
 * 事故统计保险公司 - 美团
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_MEITUAN = '美团'

/**
 * 事故统计保险公司 - 饿了么
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_ARE_YOU_HUNGRY = '饿了么'

/**
 * 事故统计保险公司 - 人寿
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_LIFE = '人寿'

/**
 * 事故统计保险公司 - 店内险
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_IN_STORE_INSURANCE = '店内险@@店内玻璃@@店内划痕'

/**
 * 事故统计保险公司 - 自费
 */
export const CSM_ACCIDENT_STATISTICS_INSURANCE_COMPANY_OWN_EXPENSE = '自费'

/**
 * 进店记录转化类别 - 首保
 */
export const CSM_INCOMING_RECORD_CONVERSION_CATEGORY_CATEGORY_0 = '0'

/**
 * 进店记录转化类别 - 保养
 */
export const CSM_INCOMING_RECORD_CONVERSION_CATEGORY_CATEGORY_2 = '2'

/**
 * 进店记录转化类别 - 维修
 */
export const CSM_INCOMING_RECORD_CONVERSION_CATEGORY_CATEGORY_3 = '3'

/**
 * 积分订单状态 - 未领取
 */
export const PMALL_POINTS_REDEEM_ORDER_STATUS_UNACCALIMED = 1000

/**
 * 积分订单状态 - 已领取
 */
export const PMALL_POINTS_REDEEM_ORDER_STATUS_RECEIVED = 2000

/**
 * 积分订单状态 - 已退货
 */
export const PMALL_POINTS_REDEEM_ORDER_STATUS_RETURNED = 3000

/**
 * 进店维修积分获取方式 - 固定分值
 */
export const PMALL_CAR_MAINTENANCE_POINTS_RULE_COMPUTE_TYPE_FIXED_SCORE = 1000

/**
 * 进店维修积分获取方式 - 比例换算
 */
export const PMALL_CAR_MAINTENANCE_POINTS_RULE_COMPUTE_TYPE_RATIO_CONVERSION = 2000

/**
 * 积分变更记录类型 - 线下消费
 */
export const PMALL_MEMBER_POINTS_CHANGE_LOG_TYPE_OFFLINE_CONSUMPTION = 1000

/**
 * 积分变更记录类型 - 兑换商品
 */
export const PMALL_MEMBER_POINTS_CHANGE_LOG_TYPE_EXCHANGE_GOODS = 2000

/**
 * 积分变更记录类型 - 积分商品退货
 */
export const PMALL_MEMBER_POINTS_CHANGE_LOG_TYPE_POINTS_PRODUCT_RETURN = 3000

/**
 * 启用状态 - 已启用
 */
export const PMALL_ENABLED_STATE_ACTIVATED = 1000

/**
 * 启用状态 - 未启用
 */
export const PMALL_ENABLED_STATE_NOT_ACTIVATED = 2000

/**
 * 上架状态 - 已上架
 */
export const PMALL_SHELF_STATUS_IT_HAS_BEEN_ADDED_TO = 1000

/**
 * 上架状态 - 未上架
 */
export const PMALL_SHELF_STATUS_NOT_LISTED = 2000

/**
 * 上架状态 - 草稿
 */
export const PMALL_SHELF_STATUS_DRAFT = 3000

/**
 * 奖励类型 - 储值
 */
export const PMALL_REWARD_TYPE_STORED_VALUE = 1000

/**
 * 奖励类型 - 卡券
 */
export const PMALL_REWARD_TYPE_COUPONS = 2000

/**
 * 权益发放触发原因 - 等级提升
 */
export const PMALL_REASONS_FOR_TRIGGERING_BENEFITS_LEVEL_UP = 1000

/**
 * 卡券导入审批状态 - 待审批
 */
export const COUPON_IMPORT_APPROVE_STATUS_PENDING = 2000

/**
 * 卡券导入审批状态 - 已通过
 */
export const COUPON_IMPORT_APPROVE_STATUS_PASSED = 3000

/**
 * 卡券导入审批状态 - 已驳回
 */
export const COUPON_IMPORT_APPROVE_STATUS_TURN_DOWN = 4000

/**
 * 导入类型 - 卡券
 */
export const COUPON_IMPORT_TYPE_COUPONS = 1000

/**
 * 导入类型 - 方案
 */
export const COUPON_IMPORT_TYPE_PROGRAM = 2000

/**
 * 导入类型 - 储值
 */
export const COUPON_IMPORT_TYPE_STORED_VALUE = 3000

/**
 * 试驾预约定义状态 - 显示
 */
export const COUPON_TEST_DRIVE_APPOINTMENT_DEFINITION_STATUS_DISPLAY = 1000

/**
 * 试驾预约定义状态 - 不显示
 */
export const COUPON_TEST_DRIVE_APPOINTMENT_DEFINITION_STATUS_DO_NOT_SHOW = 2000

/**
 * 试驾预约状态 - 未核实
 */
export const COUPON_TEST_DRIVE_APPOINTMENT_STATUS_NOT_VERIFIED = 1000

/**
 * 试驾预约状态 - 已核实
 */
export const COUPON_TEST_DRIVE_APPOINTMENT_STATUS_VERIFIED = 2000

/**
 * 试驾预约状态 - 已试驾
 */
export const COUPON_TEST_DRIVE_APPOINTMENT_STATUS_TEST_DRIVEN = 3000

/**
 * 支出或者收入 - 收入
 */
export const MEMBER_EXPENDITURE_OR_INCOME_INCOME = 1000

/**
 * 支出或者收入 - 支出
 */
export const MEMBER_EXPENDITURE_OR_INCOME_EXPENDITURE = 2000

/**
 * 积分兑换兑换方式 - 积分兑换
 */
export const MEMBER_HOW_TO_REDEEM_POINTS_REDEEM = 1000

/**
 * 积分兑换兑换方式 - 储值卡扣除
 */
export const MEMBER_HOW_TO_REDEEM_POINTS_STORED_VALUE_CARD_DEDUCTION = 2000

/**
 * 积分兑换兑换方式 - 微信支付
 */
export const MEMBER_HOW_TO_REDEEM_POINTS_WECHAT_PAY = 3000

/**
 * 积分兑换兑换方式 - 微信积分混合支付
 */
export const MEMBER_HOW_TO_REDEEM_POINTS_WECHAT_POINTS_HYBRID_PAYMENT = 4000

/**
 * 预约信息状态 - 待处理
 */
export const MEMBER_MEMBER_RESERVATION_INFO_STATUS_PENDING = 1000

/**
 * 预约信息状态 - 无效
 */
export const MEMBER_MEMBER_RESERVATION_INFO_STATUS_INVALID = 2000

/**
 * 预约信息状态 - 已预约
 */
export const MEMBER_MEMBER_RESERVATION_INFO_STATUS_BOOKED = 3000

/**
 * 预约信息类别 - 保养
 */
export const MEMBER_MEMBER_RESERVATION_INFO_TYPE_MAINTENANCE = 1000

/**
 * 预约信息类别 - 维修
 */
export const MEMBER_MEMBER_RESERVATION_INFO_TYPE_SERVICE = 2000

/**
 * 预约信息类别 - 检测
 */
export const MEMBER_MEMBER_RESERVATION_INFO_TYPE_DETECT = 3000



// WEBPACK FOOTER //
// ./src/constants/DictConstants.js